!function(i){"use strict";"function"==typeof define&&define.amd?define(["jquery"],i):"undefined"!=typeof exports?module.exports=i(require("jquery")):i(jQuery)}(function(i){"use strict";var e=window.Slick||{};(e=function(){var e=0;return function(t,o){var s,n=this;n.defaults={accessibility:!0,adaptiveHeight:!1,appendArrows:i(t),appendDots:i(t),arrows:!0,asNavFor:null,prevArrow:'<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',nextArrow:'<button class="slick-next" aria-label="Next" type="button">Next</button>',autoplay:!1,autoplaySpeed:3e3,centerMode:!1,centerPadding:"50px",cssEase:"ease",customPaging:function(e,t){return i('<button type="button" />').text(t+1)},dots:!1,dotsClass:"slick-dots",draggable:!0,easing:"linear",edgeFriction:.35,fade:!1,focusOnSelect:!1,focusOnChange:!1,infinite:!0,initialSlide:0,lazyLoad:"ondemand",mobileFirst:!1,pauseOnHover:!0,pauseOnFocus:!0,pauseOnDotsHover:!1,respondTo:"window",responsive:null,rows:1,rtl:!1,slide:"",slidesPerRow:1,slidesToShow:1,slidesToScroll:1,speed:500,swipe:!0,swipeToSlide:!1,touchMove:!0,touchThreshold:5,useCSS:!0,useTransform:!0,variableWidth:!1,vertical:!1,verticalSwiping:!1,waitForAnimate:!0,zIndex:1e3},n.initials={animating:!1,dragging:!1,autoPlayTimer:null,currentDirection:0,currentLeft:null,currentSlide:0,direction:1,$dots:null,listWidth:null,listHeight:null,loadIndex:0,$nextArrow:null,$prevArrow:null,scrolling:!1,slideCount:null,slideWidth:null,$slideTrack:null,$slides:null,sliding:!1,slideOffset:0,swipeLeft:null,swiping:!1,$list:null,touchObject:{},transformsEnabled:!1,unslicked:!1},i.extend(n,n.initials),n.activeBreakpoint=null,n.animType=null,n.animProp=null,n.breakpoints=[],n.breakpointSettings=[],n.cssTransitions=!1,n.focussed=!1,n.interrupted=!1,n.hidden="hidden",n.paused=!0,n.positionProp=null,n.respondTo=null,n.rowCount=1,n.shouldClick=!0,n.$slider=i(t),n.$slidesCache=null,n.transformType=null,n.transitionType=null,n.visibilityChange="visibilitychange",n.windowWidth=0,n.windowTimer=null,s=i(t).data("slick")||{},n.options=i.extend({},n.defaults,o,s),n.currentSlide=n.options.initialSlide,n.originalSettings=n.options,void 0!==document.mozHidden?(n.hidden="mozHidden",n.visibilityChange="mozvisibilitychange"):void 0!==document.webkitHidden&&(n.hidden="webkitHidden",n.visibilityChange="webkitvisibilitychange"),n.autoPlay=i.proxy(n.autoPlay,n),n.autoPlayClear=i.proxy(n.autoPlayClear,n),n.autoPlayIterator=i.proxy(n.autoPlayIterator,n),n.changeSlide=i.proxy(n.changeSlide,n),n.clickHandler=i.proxy(n.clickHandler,n),n.selectHandler=i.proxy(n.selectHandler,n),n.setPosition=i.proxy(n.setPosition,n),n.swipeHandler=i.proxy(n.swipeHandler,n),n.dragHandler=i.proxy(n.dragHandler,n),n.keyHandler=i.proxy(n.keyHandler,n),n.instanceUid=e++,n.htmlExpr=/^(?:\s*(<[\w\W]+>)[^>]*)$/,n.registerBreakpoints(),n.init(!0)}}()).prototype.activateADA=function(){this.$slideTrack.find(".slick-active").attr({"aria-hidden":"false"}).find("a, input, button, select").attr({tabindex:"0"})},e.prototype.addSlide=e.prototype.slickAdd=function(e,t,o){var s=this;if("boolean"==typeof t)o=t,t=null;else if(t<0||t>=s.slideCount)return!1;s.unload(),"number"==typeof t?0===t&&0===s.$slides.length?i(e).appendTo(s.$slideTrack):o?i(e).insertBefore(s.$slides.eq(t)):i(e).insertAfter(s.$slides.eq(t)):!0===o?i(e).prependTo(s.$slideTrack):i(e).appendTo(s.$slideTrack),s.$slides=s.$slideTrack.children(this.options.slide),s.$slideTrack.children(this.options.slide).detach(),s.$slideTrack.append(s.$slides),s.$slides.each(function(e,t){i(t).attr("data-slick-index",e)}),s.$slidesCache=s.$slides,s.reinit()},e.prototype.animateHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.animate({height:e},i.options.speed)}},e.prototype.animateSlide=function(e,t){var o={},s=this;s.animateHeight(),!0===s.options.rtl&&!1===s.options.vertical&&(e=-e),!1===s.transformsEnabled?!1===s.options.vertical?s.$slideTrack.animate({left:e},s.options.speed,s.options.easing,t):s.$slideTrack.animate({top:e},s.options.speed,s.options.easing,t):!1===s.cssTransitions?(!0===s.options.rtl&&(s.currentLeft=-s.currentLeft),i({animStart:s.currentLeft}).animate({animStart:e},{duration:s.options.speed,easing:s.options.easing,step:function(i){i=Math.ceil(i),!1===s.options.vertical?(o[s.animType]="translate("+i+"px, 0px)",s.$slideTrack.css(o)):(o[s.animType]="translate(0px,"+i+"px)",s.$slideTrack.css(o))},complete:function(){t&&t.call()}})):(s.applyTransition(),e=Math.ceil(e),!1===s.options.vertical?o[s.animType]="translate3d("+e+"px, 0px, 0px)":o[s.animType]="translate3d(0px,"+e+"px, 0px)",s.$slideTrack.css(o),t&&setTimeout(function(){s.disableTransition(),t.call()},s.options.speed))},e.prototype.getNavTarget=function(){var e=this,t=e.options.asNavFor;return t&&null!==t&&(t=i(t).not(e.$slider)),t},e.prototype.asNavFor=function(e){var t=this.getNavTarget();null!==t&&"object"==typeof t&&t.each(function(){var t=i(this).slick("getSlick");t.unslicked||t.slideHandler(e,!0)})},e.prototype.applyTransition=function(i){var e=this,t={};!1===e.options.fade?t[e.transitionType]=e.transformType+" "+e.options.speed+"ms "+e.options.cssEase:t[e.transitionType]="opacity "+e.options.speed+"ms "+e.options.cssEase,!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.autoPlay=function(){var i=this;i.autoPlayClear(),i.slideCount>i.options.slidesToShow&&(i.autoPlayTimer=setInterval(i.autoPlayIterator,i.options.autoplaySpeed))},e.prototype.autoPlayClear=function(){var i=this;i.autoPlayTimer&&clearInterval(i.autoPlayTimer)},e.prototype.autoPlayIterator=function(){var i=this,e=i.currentSlide+i.options.slidesToScroll;i.paused||i.interrupted||i.focussed||(!1===i.options.infinite&&(1===i.direction&&i.currentSlide+1===i.slideCount-1?i.direction=0:0===i.direction&&(e=i.currentSlide-i.options.slidesToScroll,i.currentSlide-1==0&&(i.direction=1))),i.slideHandler(e))},e.prototype.buildArrows=function(){var e=this;!0===e.options.arrows&&(e.$prevArrow=i(e.options.prevArrow).addClass("slick-arrow"),e.$nextArrow=i(e.options.nextArrow).addClass("slick-arrow"),e.slideCount>e.options.slidesToShow?(e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.prependTo(e.options.appendArrows),e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.appendTo(e.options.appendArrows),!0!==e.options.infinite&&e.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true")):e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({"aria-disabled":"true",tabindex:"-1"}))},e.prototype.buildDots=function(){var e,t,o=this;if(!0===o.options.dots){for(o.$slider.addClass("slick-dotted"),t=i("<ul />").addClass(o.options.dotsClass),e=0;e<=o.getDotCount();e+=1)t.append(i("<li />").append(o.options.customPaging.call(this,o,e)));o.$dots=t.appendTo(o.options.appendDots),o.$dots.find("li").first().addClass("slick-active")}},e.prototype.buildOut=function(){var e=this;e.$slides=e.$slider.children(e.options.slide+":not(.slick-cloned)").addClass("slick-slide"),e.slideCount=e.$slides.length,e.$slides.each(function(e,t){i(t).attr("data-slick-index",e).data("originalStyling",i(t).attr("style")||"")}),e.$slider.addClass("slick-slider"),e.$slideTrack=0===e.slideCount?i('<div class="slick-track"/>').appendTo(e.$slider):e.$slides.wrapAll('<div class="slick-track"/>').parent(),e.$list=e.$slideTrack.wrap('<div class="slick-list"/>').parent(),e.$slideTrack.css("opacity",0),!0!==e.options.centerMode&&!0!==e.options.swipeToSlide||(e.options.slidesToScroll=1),i("img[data-lazy]",e.$slider).not("[src]").addClass("slick-loading"),e.setupInfinite(),e.buildArrows(),e.buildDots(),e.updateDots(),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),!0===e.options.draggable&&e.$list.addClass("draggable")},e.prototype.buildRows=function(){var i,e,t,o,s,n,r,l=this;if(o=document.createDocumentFragment(),n=l.$slider.children(),l.options.rows>1){for(r=l.options.slidesPerRow*l.options.rows,s=Math.ceil(n.length/r),i=0;i<s;i++){var d=document.createElement("div");for(e=0;e<l.options.rows;e++){var a=document.createElement("div");for(t=0;t<l.options.slidesPerRow;t++){var c=i*r+(e*l.options.slidesPerRow+t);n.get(c)&&a.appendChild(n.get(c))}d.appendChild(a)}o.appendChild(d)}l.$slider.empty().append(o),l.$slider.children().children().children().css({width:100/l.options.slidesPerRow+"%",display:"inline-block"})}},e.prototype.checkResponsive=function(e,t){var o,s,n,r=this,l=!1,d=r.$slider.width(),a=window.innerWidth||i(window).width();if("window"===r.respondTo?n=a:"slider"===r.respondTo?n=d:"min"===r.respondTo&&(n=Math.min(a,d)),r.options.responsive&&r.options.responsive.length&&null!==r.options.responsive){s=null;for(o in r.breakpoints)r.breakpoints.hasOwnProperty(o)&&(!1===r.originalSettings.mobileFirst?n<r.breakpoints[o]&&(s=r.breakpoints[o]):n>r.breakpoints[o]&&(s=r.breakpoints[o]));null!==s?null!==r.activeBreakpoint?(s!==r.activeBreakpoint||t)&&(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):null!==r.activeBreakpoint&&(r.activeBreakpoint=null,r.options=r.originalSettings,!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e),l=s),e||!1===l||r.$slider.trigger("breakpoint",[r,l])}},e.prototype.changeSlide=function(e,t){var o,s,n,r=this,l=i(e.currentTarget);switch(l.is("a")&&e.preventDefault(),l.is("li")||(l=l.closest("li")),n=r.slideCount%r.options.slidesToScroll!=0,o=n?0:(r.slideCount-r.currentSlide)%r.options.slidesToScroll,e.data.message){case"previous":s=0===o?r.options.slidesToScroll:r.options.slidesToShow-o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide-s,!1,t);break;case"next":s=0===o?r.options.slidesToScroll:o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide+s,!1,t);break;case"index":var d=0===e.data.index?0:e.data.index||l.index()*r.options.slidesToScroll;r.slideHandler(r.checkNavigable(d),!1,t),l.children().trigger("focus");break;default:return}},e.prototype.checkNavigable=function(i){var e,t;if(e=this.getNavigableIndexes(),t=0,i>e[e.length-1])i=e[e.length-1];else for(var o in e){if(i<e[o]){i=t;break}t=e[o]}return i},e.prototype.cleanUpEvents=function(){var e=this;e.options.dots&&null!==e.$dots&&(i("li",e.$dots).off("click.slick",e.changeSlide).off("mouseenter.slick",i.proxy(e.interrupt,e,!0)).off("mouseleave.slick",i.proxy(e.interrupt,e,!1)),!0===e.options.accessibility&&e.$dots.off("keydown.slick",e.keyHandler)),e.$slider.off("focus.slick blur.slick"),!0===e.options.arrows&&e.slideCount>e.options.slidesToShow&&(e.$prevArrow&&e.$prevArrow.off("click.slick",e.changeSlide),e.$nextArrow&&e.$nextArrow.off("click.slick",e.changeSlide),!0===e.options.accessibility&&(e.$prevArrow&&e.$prevArrow.off("keydown.slick",e.keyHandler),e.$nextArrow&&e.$nextArrow.off("keydown.slick",e.keyHandler))),e.$list.off("touchstart.slick mousedown.slick",e.swipeHandler),e.$list.off("touchmove.slick mousemove.slick",e.swipeHandler),e.$list.off("touchend.slick mouseup.slick",e.swipeHandler),e.$list.off("touchcancel.slick mouseleave.slick",e.swipeHandler),e.$list.off("click.slick",e.clickHandler),i(document).off(e.visibilityChange,e.visibility),e.cleanUpSlideEvents(),!0===e.options.accessibility&&e.$list.off("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().off("click.slick",e.selectHandler),i(window).off("orientationchange.slick.slick-"+e.instanceUid,e.orientationChange),i(window).off("resize.slick.slick-"+e.instanceUid,e.resize),i("[draggable!=true]",e.$slideTrack).off("dragstart",e.preventDefault),i(window).off("load.slick.slick-"+e.instanceUid,e.setPosition)},e.prototype.cleanUpSlideEvents=function(){var e=this;e.$list.off("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.off("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.cleanUpRows=function(){var i,e=this;e.options.rows>1&&((i=e.$slides.children().children()).removeAttr("style"),e.$slider.empty().append(i))},e.prototype.clickHandler=function(i){!1===this.shouldClick&&(i.stopImmediatePropagation(),i.stopPropagation(),i.preventDefault())},e.prototype.destroy=function(e){var t=this;t.autoPlayClear(),t.touchObject={},t.cleanUpEvents(),i(".slick-cloned",t.$slider).detach(),t.$dots&&t.$dots.remove(),t.$prevArrow&&t.$prevArrow.length&&(t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.prevArrow)&&t.$prevArrow.remove()),t.$nextArrow&&t.$nextArrow.length&&(t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.nextArrow)&&t.$nextArrow.remove()),t.$slides&&(t.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function(){i(this).attr("style",i(this).data("originalStyling"))}),t.$slideTrack.children(this.options.slide).detach(),t.$slideTrack.detach(),t.$list.detach(),t.$slider.append(t.$slides)),t.cleanUpRows(),t.$slider.removeClass("slick-slider"),t.$slider.removeClass("slick-initialized"),t.$slider.removeClass("slick-dotted"),t.unslicked=!0,e||t.$slider.trigger("destroy",[t])},e.prototype.disableTransition=function(i){var e=this,t={};t[e.transitionType]="",!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.fadeSlide=function(i,e){var t=this;!1===t.cssTransitions?(t.$slides.eq(i).css({zIndex:t.options.zIndex}),t.$slides.eq(i).animate({opacity:1},t.options.speed,t.options.easing,e)):(t.applyTransition(i),t.$slides.eq(i).css({opacity:1,zIndex:t.options.zIndex}),e&&setTimeout(function(){t.disableTransition(i),e.call()},t.options.speed))},e.prototype.fadeSlideOut=function(i){var e=this;!1===e.cssTransitions?e.$slides.eq(i).animate({opacity:0,zIndex:e.options.zIndex-2},e.options.speed,e.options.easing):(e.applyTransition(i),e.$slides.eq(i).css({opacity:0,zIndex:e.options.zIndex-2}))},e.prototype.filterSlides=e.prototype.slickFilter=function(i){var e=this;null!==i&&(e.$slidesCache=e.$slides,e.unload(),e.$slideTrack.children(this.options.slide).detach(),e.$slidesCache.filter(i).appendTo(e.$slideTrack),e.reinit())},e.prototype.focusHandler=function(){var e=this;e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick","*",function(t){t.stopImmediatePropagation();var o=i(this);setTimeout(function(){e.options.pauseOnFocus&&(e.focussed=o.is(":focus"),e.autoPlay())},0)})},e.prototype.getCurrent=e.prototype.slickCurrentSlide=function(){return this.currentSlide},e.prototype.getDotCount=function(){var i=this,e=0,t=0,o=0;if(!0===i.options.infinite)if(i.slideCount<=i.options.slidesToShow)++o;else for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else if(!0===i.options.centerMode)o=i.slideCount;else if(i.options.asNavFor)for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else o=1+Math.ceil((i.slideCount-i.options.slidesToShow)/i.options.slidesToScroll);return o-1},e.prototype.getLeft=function(i){var e,t,o,s,n=this,r=0;return n.slideOffset=0,t=n.$slides.first().outerHeight(!0),!0===n.options.infinite?(n.slideCount>n.options.slidesToShow&&(n.slideOffset=n.slideWidth*n.options.slidesToShow*-1,s=-1,!0===n.options.vertical&&!0===n.options.centerMode&&(2===n.options.slidesToShow?s=-1.5:1===n.options.slidesToShow&&(s=-2)),r=t*n.options.slidesToShow*s),n.slideCount%n.options.slidesToScroll!=0&&i+n.options.slidesToScroll>n.slideCount&&n.slideCount>n.options.slidesToShow&&(i>n.slideCount?(n.slideOffset=(n.options.slidesToShow-(i-n.slideCount))*n.slideWidth*-1,r=(n.options.slidesToShow-(i-n.slideCount))*t*-1):(n.slideOffset=n.slideCount%n.options.slidesToScroll*n.slideWidth*-1,r=n.slideCount%n.options.slidesToScroll*t*-1))):i+n.options.slidesToShow>n.slideCount&&(n.slideOffset=(i+n.options.slidesToShow-n.slideCount)*n.slideWidth,r=(i+n.options.slidesToShow-n.slideCount)*t),n.slideCount<=n.options.slidesToShow&&(n.slideOffset=0,r=0),!0===n.options.centerMode&&n.slideCount<=n.options.slidesToShow?n.slideOffset=n.slideWidth*Math.floor(n.options.slidesToShow)/2-n.slideWidth*n.slideCount/2:!0===n.options.centerMode&&!0===n.options.infinite?n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)-n.slideWidth:!0===n.options.centerMode&&(n.slideOffset=0,n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)),e=!1===n.options.vertical?i*n.slideWidth*-1+n.slideOffset:i*t*-1+r,!0===n.options.variableWidth&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,!0===n.options.centerMode&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow+1),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,e+=(n.$list.width()-o.outerWidth())/2)),e},e.prototype.getOption=e.prototype.slickGetOption=function(i){return this.options[i]},e.prototype.getNavigableIndexes=function(){var i,e=this,t=0,o=0,s=[];for(!1===e.options.infinite?i=e.slideCount:(t=-1*e.options.slidesToScroll,o=-1*e.options.slidesToScroll,i=2*e.slideCount);t<i;)s.push(t),t=o+e.options.slidesToScroll,o+=e.options.slidesToScroll<=e.options.slidesToShow?e.options.slidesToScroll:e.options.slidesToShow;return s},e.prototype.getSlick=function(){return this},e.prototype.getSlideCount=function(){var e,t,o=this;return t=!0===o.options.centerMode?o.slideWidth*Math.floor(o.options.slidesToShow/2):0,!0===o.options.swipeToSlide?(o.$slideTrack.find(".slick-slide").each(function(s,n){if(n.offsetLeft-t+i(n).outerWidth()/2>-1*o.swipeLeft)return e=n,!1}),Math.abs(i(e).attr("data-slick-index")-o.currentSlide)||1):o.options.slidesToScroll},e.prototype.goTo=e.prototype.slickGoTo=function(i,e){this.changeSlide({data:{message:"index",index:parseInt(i)}},e)},e.prototype.init=function(e){var t=this;i(t.$slider).hasClass("slick-initialized")||(i(t.$slider).addClass("slick-initialized"),t.buildRows(),t.buildOut(),t.setProps(),t.startLoad(),t.loadSlider(),t.initializeEvents(),t.updateArrows(),t.updateDots(),t.checkResponsive(!0),t.focusHandler()),e&&t.$slider.trigger("init",[t]),!0===t.options.accessibility&&t.initADA(),t.options.autoplay&&(t.paused=!1,t.autoPlay())},e.prototype.initADA=function(){var e=this,t=Math.ceil(e.slideCount/e.options.slidesToShow),o=e.getNavigableIndexes().filter(function(i){return i>=0&&i<e.slideCount});e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({"aria-hidden":"true",tabindex:"-1"}).find("a, input, button, select").attr({tabindex:"-1"}),null!==e.$dots&&(e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function(t){var s=o.indexOf(t);i(this).attr({role:"tabpanel",id:"slick-slide"+e.instanceUid+t,tabindex:-1}),-1!==s&&i(this).attr({"aria-describedby":"slick-slide-control"+e.instanceUid+s})}),e.$dots.attr("role","tablist").find("li").each(function(s){var n=o[s];i(this).attr({role:"presentation"}),i(this).find("button").first().attr({role:"tab",id:"slick-slide-control"+e.instanceUid+s,"aria-controls":"slick-slide"+e.instanceUid+n,"aria-label":s+1+" of "+t,"aria-selected":null,tabindex:"-1"})}).eq(e.currentSlide).find("button").attr({"aria-selected":"true",tabindex:"0"}).end());for(var s=e.currentSlide,n=s+e.options.slidesToShow;s<n;s++)e.$slides.eq(s).attr("tabindex",0);e.activateADA()},e.prototype.initArrowEvents=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.off("click.slick").on("click.slick",{message:"previous"},i.changeSlide),i.$nextArrow.off("click.slick").on("click.slick",{message:"next"},i.changeSlide),!0===i.options.accessibility&&(i.$prevArrow.on("keydown.slick",i.keyHandler),i.$nextArrow.on("keydown.slick",i.keyHandler)))},e.prototype.initDotEvents=function(){var e=this;!0===e.options.dots&&(i("li",e.$dots).on("click.slick",{message:"index"},e.changeSlide),!0===e.options.accessibility&&e.$dots.on("keydown.slick",e.keyHandler)),!0===e.options.dots&&!0===e.options.pauseOnDotsHover&&i("li",e.$dots).on("mouseenter.slick",i.proxy(e.interrupt,e,!0)).on("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.initSlideEvents=function(){var e=this;e.options.pauseOnHover&&(e.$list.on("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.on("mouseleave.slick",i.proxy(e.interrupt,e,!1)))},e.prototype.initializeEvents=function(){var e=this;e.initArrowEvents(),e.initDotEvents(),e.initSlideEvents(),e.$list.on("touchstart.slick mousedown.slick",{action:"start"},e.swipeHandler),e.$list.on("touchmove.slick mousemove.slick",{action:"move"},e.swipeHandler),e.$list.on("touchend.slick mouseup.slick",{action:"end"},e.swipeHandler),e.$list.on("touchcancel.slick mouseleave.slick",{action:"end"},e.swipeHandler),e.$list.on("click.slick",e.clickHandler),i(document).on(e.visibilityChange,i.proxy(e.visibility,e)),!0===e.options.accessibility&&e.$list.on("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),i(window).on("orientationchange.slick.slick-"+e.instanceUid,i.proxy(e.orientationChange,e)),i(window).on("resize.slick.slick-"+e.instanceUid,i.proxy(e.resize,e)),i("[draggable!=true]",e.$slideTrack).on("dragstart",e.preventDefault),i(window).on("load.slick.slick-"+e.instanceUid,e.setPosition),i(e.setPosition)},e.prototype.initUI=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.show(),i.$nextArrow.show()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.show()},e.prototype.keyHandler=function(i){var e=this;i.target.tagName.match("TEXTAREA|INPUT|SELECT")||(37===i.keyCode&&!0===e.options.accessibility?e.changeSlide({data:{message:!0===e.options.rtl?"next":"previous"}}):39===i.keyCode&&!0===e.options.accessibility&&e.changeSlide({data:{message:!0===e.options.rtl?"previous":"next"}}))},e.prototype.lazyLoad=function(){function e(e){i("img[data-lazy]",e).each(function(){var e=i(this),t=i(this).attr("data-lazy"),o=i(this).attr("data-srcset"),s=i(this).attr("data-sizes")||n.$slider.attr("data-sizes"),r=document.createElement("img");r.onload=function(){e.animate({opacity:0},100,function(){o&&(e.attr("srcset",o),s&&e.attr("sizes",s)),e.attr("src",t).animate({opacity:1},200,function(){e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")}),n.$slider.trigger("lazyLoaded",[n,e,t])})},r.onerror=function(){e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),n.$slider.trigger("lazyLoadError",[n,e,t])},r.src=t})}var t,o,s,n=this;if(!0===n.options.centerMode?!0===n.options.infinite?s=(o=n.currentSlide+(n.options.slidesToShow/2+1))+n.options.slidesToShow+2:(o=Math.max(0,n.currentSlide-(n.options.slidesToShow/2+1)),s=n.options.slidesToShow/2+1+2+n.currentSlide):(o=n.options.infinite?n.options.slidesToShow+n.currentSlide:n.currentSlide,s=Math.ceil(o+n.options.slidesToShow),!0===n.options.fade&&(o>0&&o--,s<=n.slideCount&&s++)),t=n.$slider.find(".slick-slide").slice(o,s),"anticipated"===n.options.lazyLoad)for(var r=o-1,l=s,d=n.$slider.find(".slick-slide"),a=0;a<n.options.slidesToScroll;a++)r<0&&(r=n.slideCount-1),t=(t=t.add(d.eq(r))).add(d.eq(l)),r--,l++;e(t),n.slideCount<=n.options.slidesToShow?e(n.$slider.find(".slick-slide")):n.currentSlide>=n.slideCount-n.options.slidesToShow?e(n.$slider.find(".slick-cloned").slice(0,n.options.slidesToShow)):0===n.currentSlide&&e(n.$slider.find(".slick-cloned").slice(-1*n.options.slidesToShow))},e.prototype.loadSlider=function(){var i=this;i.setPosition(),i.$slideTrack.css({opacity:1}),i.$slider.removeClass("slick-loading"),i.initUI(),"progressive"===i.options.lazyLoad&&i.progressiveLazyLoad()},e.prototype.next=e.prototype.slickNext=function(){this.changeSlide({data:{message:"next"}})},e.prototype.orientationChange=function(){var i=this;i.checkResponsive(),i.setPosition()},e.prototype.pause=e.prototype.slickPause=function(){var i=this;i.autoPlayClear(),i.paused=!0},e.prototype.play=e.prototype.slickPlay=function(){var i=this;i.autoPlay(),i.options.autoplay=!0,i.paused=!1,i.focussed=!1,i.interrupted=!1},e.prototype.postSlide=function(e){var t=this;t.unslicked||(t.$slider.trigger("afterChange",[t,e]),t.animating=!1,t.slideCount>t.options.slidesToShow&&t.setPosition(),t.swipeLeft=null,t.options.autoplay&&t.autoPlay(),!0===t.options.accessibility&&(t.initADA(),t.options.focusOnChange&&i(t.$slides.get(t.currentSlide)).attr("tabindex",0).focus()))},e.prototype.prev=e.prototype.slickPrev=function(){this.changeSlide({data:{message:"previous"}})},e.prototype.preventDefault=function(i){i.preventDefault()},e.prototype.progressiveLazyLoad=function(e){e=e||1;var t,o,s,n,r,l=this,d=i("img[data-lazy]",l.$slider);d.length?(t=d.first(),o=t.attr("data-lazy"),s=t.attr("data-srcset"),n=t.attr("data-sizes")||l.$slider.attr("data-sizes"),(r=document.createElement("img")).onload=function(){s&&(t.attr("srcset",s),n&&t.attr("sizes",n)),t.attr("src",o).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"),!0===l.options.adaptiveHeight&&l.setPosition(),l.$slider.trigger("lazyLoaded",[l,t,o]),l.progressiveLazyLoad()},r.onerror=function(){e<3?setTimeout(function(){l.progressiveLazyLoad(e+1)},500):(t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),l.$slider.trigger("lazyLoadError",[l,t,o]),l.progressiveLazyLoad())},r.src=o):l.$slider.trigger("allImagesLoaded",[l])},e.prototype.refresh=function(e){var t,o,s=this;o=s.slideCount-s.options.slidesToShow,!s.options.infinite&&s.currentSlide>o&&(s.currentSlide=o),s.slideCount<=s.options.slidesToShow&&(s.currentSlide=0),t=s.currentSlide,s.destroy(!0),i.extend(s,s.initials,{currentSlide:t}),s.init(),e||s.changeSlide({data:{message:"index",index:t}},!1)},e.prototype.registerBreakpoints=function(){var e,t,o,s=this,n=s.options.responsive||null;if("array"===i.type(n)&&n.length){s.respondTo=s.options.respondTo||"window";for(e in n)if(o=s.breakpoints.length-1,n.hasOwnProperty(e)){for(t=n[e].breakpoint;o>=0;)s.breakpoints[o]&&s.breakpoints[o]===t&&s.breakpoints.splice(o,1),o--;s.breakpoints.push(t),s.breakpointSettings[t]=n[e].settings}s.breakpoints.sort(function(i,e){return s.options.mobileFirst?i-e:e-i})}},e.prototype.reinit=function(){var e=this;e.$slides=e.$slideTrack.children(e.options.slide).addClass("slick-slide"),e.slideCount=e.$slides.length,e.currentSlide>=e.slideCount&&0!==e.currentSlide&&(e.currentSlide=e.currentSlide-e.options.slidesToScroll),e.slideCount<=e.options.slidesToShow&&(e.currentSlide=0),e.registerBreakpoints(),e.setProps(),e.setupInfinite(),e.buildArrows(),e.updateArrows(),e.initArrowEvents(),e.buildDots(),e.updateDots(),e.initDotEvents(),e.cleanUpSlideEvents(),e.initSlideEvents(),e.checkResponsive(!1,!0),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),e.setPosition(),e.focusHandler(),e.paused=!e.options.autoplay,e.autoPlay(),e.$slider.trigger("reInit",[e])},e.prototype.resize=function(){var e=this;i(window).width()!==e.windowWidth&&(clearTimeout(e.windowDelay),e.windowDelay=window.setTimeout(function(){e.windowWidth=i(window).width(),e.checkResponsive(),e.unslicked||e.setPosition()},50))},e.prototype.removeSlide=e.prototype.slickRemove=function(i,e,t){var o=this;if(i="boolean"==typeof i?!0===(e=i)?0:o.slideCount-1:!0===e?--i:i,o.slideCount<1||i<0||i>o.slideCount-1)return!1;o.unload(),!0===t?o.$slideTrack.children().remove():o.$slideTrack.children(this.options.slide).eq(i).remove(),o.$slides=o.$slideTrack.children(this.options.slide),o.$slideTrack.children(this.options.slide).detach(),o.$slideTrack.append(o.$slides),o.$slidesCache=o.$slides,o.reinit()},e.prototype.setCSS=function(i){var e,t,o=this,s={};!0===o.options.rtl&&(i=-i),e="left"==o.positionProp?Math.ceil(i)+"px":"0px",t="top"==o.positionProp?Math.ceil(i)+"px":"0px",s[o.positionProp]=i,!1===o.transformsEnabled?o.$slideTrack.css(s):(s={},!1===o.cssTransitions?(s[o.animType]="translate("+e+", "+t+")",o.$slideTrack.css(s)):(s[o.animType]="translate3d("+e+", "+t+", 0px)",o.$slideTrack.css(s)))},e.prototype.setDimensions=function(){var i=this;!1===i.options.vertical?!0===i.options.centerMode&&i.$list.css({padding:"0px "+i.options.centerPadding}):(i.$list.height(i.$slides.first().outerHeight(!0)*i.options.slidesToShow),!0===i.options.centerMode&&i.$list.css({padding:i.options.centerPadding+" 0px"})),i.listWidth=i.$list.width(),i.listHeight=i.$list.height(),!1===i.options.vertical&&!1===i.options.variableWidth?(i.slideWidth=Math.ceil(i.listWidth/i.options.slidesToShow),i.$slideTrack.width(Math.ceil(i.slideWidth*i.$slideTrack.children(".slick-slide").length))):!0===i.options.variableWidth?i.$slideTrack.width(5e3*i.slideCount):(i.slideWidth=Math.ceil(i.listWidth),i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0)*i.$slideTrack.children(".slick-slide").length)));var e=i.$slides.first().outerWidth(!0)-i.$slides.first().width();!1===i.options.variableWidth&&i.$slideTrack.children(".slick-slide").width(i.slideWidth-e)},e.prototype.setFade=function(){var e,t=this;t.$slides.each(function(o,s){e=t.slideWidth*o*-1,!0===t.options.rtl?i(s).css({position:"relative",right:e,top:0,zIndex:t.options.zIndex-2,opacity:0}):i(s).css({position:"relative",left:e,top:0,zIndex:t.options.zIndex-2,opacity:0})}),t.$slides.eq(t.currentSlide).css({zIndex:t.options.zIndex-1,opacity:1})},e.prototype.setHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.css("height",e)}},e.prototype.setOption=e.prototype.slickSetOption=function(){var e,t,o,s,n,r=this,l=!1;if("object"===i.type(arguments[0])?(o=arguments[0],l=arguments[1],n="multiple"):"string"===i.type(arguments[0])&&(o=arguments[0],s=arguments[1],l=arguments[2],"responsive"===arguments[0]&&"array"===i.type(arguments[1])?n="responsive":void 0!==arguments[1]&&(n="single")),"single"===n)r.options[o]=s;else if("multiple"===n)i.each(o,function(i,e){r.options[i]=e});else if("responsive"===n)for(t in s)if("array"!==i.type(r.options.responsive))r.options.responsive=[s[t]];else{for(e=r.options.responsive.length-1;e>=0;)r.options.responsive[e].breakpoint===s[t].breakpoint&&r.options.responsive.splice(e,1),e--;r.options.responsive.push(s[t])}l&&(r.unload(),r.reinit())},e.prototype.setPosition=function(){var i=this;i.setDimensions(),i.setHeight(),!1===i.options.fade?i.setCSS(i.getLeft(i.currentSlide)):i.setFade(),i.$slider.trigger("setPosition",[i])},e.prototype.setProps=function(){var i=this,e=document.body.style;i.positionProp=!0===i.options.vertical?"top":"left","top"===i.positionProp?i.$slider.addClass("slick-vertical"):i.$slider.removeClass("slick-vertical"),void 0===e.WebkitTransition&&void 0===e.MozTransition&&void 0===e.msTransition||!0===i.options.useCSS&&(i.cssTransitions=!0),i.options.fade&&("number"==typeof i.options.zIndex?i.options.zIndex<3&&(i.options.zIndex=3):i.options.zIndex=i.defaults.zIndex),void 0!==e.OTransform&&(i.animType="OTransform",i.transformType="-o-transform",i.transitionType="OTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.MozTransform&&(i.animType="MozTransform",i.transformType="-moz-transform",i.transitionType="MozTransition",void 0===e.perspectiveProperty&&void 0===e.MozPerspective&&(i.animType=!1)),void 0!==e.webkitTransform&&(i.animType="webkitTransform",i.transformType="-webkit-transform",i.transitionType="webkitTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.msTransform&&(i.animType="msTransform",i.transformType="-ms-transform",i.transitionType="msTransition",void 0===e.msTransform&&(i.animType=!1)),void 0!==e.transform&&!1!==i.animType&&(i.animType="transform",i.transformType="transform",i.transitionType="transition"),i.transformsEnabled=i.options.useTransform&&null!==i.animType&&!1!==i.animType},e.prototype.setSlideClasses=function(i){var e,t,o,s,n=this;if(t=n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden","true"),n.$slides.eq(i).addClass("slick-current"),!0===n.options.centerMode){var r=n.options.slidesToShow%2==0?1:0;e=Math.floor(n.options.slidesToShow/2),!0===n.options.infinite&&(i>=e&&i<=n.slideCount-1-e?n.$slides.slice(i-e+r,i+e+1).addClass("slick-active").attr("aria-hidden","false"):(o=n.options.slidesToShow+i,t.slice(o-e+1+r,o+e+2).addClass("slick-active").attr("aria-hidden","false")),0===i?t.eq(t.length-1-n.options.slidesToShow).addClass("slick-center"):i===n.slideCount-1&&t.eq(n.options.slidesToShow).addClass("slick-center")),n.$slides.eq(i).addClass("slick-center")}else i>=0&&i<=n.slideCount-n.options.slidesToShow?n.$slides.slice(i,i+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"):t.length<=n.options.slidesToShow?t.addClass("slick-active").attr("aria-hidden","false"):(s=n.slideCount%n.options.slidesToShow,o=!0===n.options.infinite?n.options.slidesToShow+i:i,n.options.slidesToShow==n.options.slidesToScroll&&n.slideCount-i<n.options.slidesToShow?t.slice(o-(n.options.slidesToShow-s),o+s).addClass("slick-active").attr("aria-hidden","false"):t.slice(o,o+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"));"ondemand"!==n.options.lazyLoad&&"anticipated"!==n.options.lazyLoad||n.lazyLoad()},e.prototype.setupInfinite=function(){var e,t,o,s=this;if(!0===s.options.fade&&(s.options.centerMode=!1),!0===s.options.infinite&&!1===s.options.fade&&(t=null,s.slideCount>s.options.slidesToShow)){for(o=!0===s.options.centerMode?s.options.slidesToShow+1:s.options.slidesToShow,e=s.slideCount;e>s.slideCount-o;e-=1)t=e-1,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t-s.slideCount).prependTo(s.$slideTrack).addClass("slick-cloned");for(e=0;e<o+s.slideCount;e+=1)t=e,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t+s.slideCount).appendTo(s.$slideTrack).addClass("slick-cloned");s.$slideTrack.find(".slick-cloned").find("[id]").each(function(){i(this).attr("id","")})}},e.prototype.interrupt=function(i){var e=this;i||e.autoPlay(),e.interrupted=i},e.prototype.selectHandler=function(e){var t=this,o=i(e.target).is(".slick-slide")?i(e.target):i(e.target).parents(".slick-slide"),s=parseInt(o.attr("data-slick-index"));s||(s=0),t.slideCount<=t.options.slidesToShow?t.slideHandler(s,!1,!0):t.slideHandler(s)},e.prototype.slideHandler=function(i,e,t){var o,s,n,r,l,d=null,a=this;if(e=e||!1,!(!0===a.animating&&!0===a.options.waitForAnimate||!0===a.options.fade&&a.currentSlide===i))if(!1===e&&a.asNavFor(i),o=i,d=a.getLeft(o),r=a.getLeft(a.currentSlide),a.currentLeft=null===a.swipeLeft?r:a.swipeLeft,!1===a.options.infinite&&!1===a.options.centerMode&&(i<0||i>a.getDotCount()*a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else if(!1===a.options.infinite&&!0===a.options.centerMode&&(i<0||i>a.slideCount-a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else{if(a.options.autoplay&&clearInterval(a.autoPlayTimer),s=o<0?a.slideCount%a.options.slidesToScroll!=0?a.slideCount-a.slideCount%a.options.slidesToScroll:a.slideCount+o:o>=a.slideCount?a.slideCount%a.options.slidesToScroll!=0?0:o-a.slideCount:o,a.animating=!0,a.$slider.trigger("beforeChange",[a,a.currentSlide,s]),n=a.currentSlide,a.currentSlide=s,a.setSlideClasses(a.currentSlide),a.options.asNavFor&&(l=(l=a.getNavTarget()).slick("getSlick")).slideCount<=l.options.slidesToShow&&l.setSlideClasses(a.currentSlide),a.updateDots(),a.updateArrows(),!0===a.options.fade)return!0!==t?(a.fadeSlideOut(n),a.fadeSlide(s,function(){a.postSlide(s)})):a.postSlide(s),void a.animateHeight();!0!==t?a.animateSlide(d,function(){a.postSlide(s)}):a.postSlide(s)}},e.prototype.startLoad=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.hide(),i.$nextArrow.hide()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.hide(),i.$slider.addClass("slick-loading")},e.prototype.swipeDirection=function(){var i,e,t,o,s=this;return i=s.touchObject.startX-s.touchObject.curX,e=s.touchObject.startY-s.touchObject.curY,t=Math.atan2(e,i),(o=Math.round(180*t/Math.PI))<0&&(o=360-Math.abs(o)),o<=45&&o>=0?!1===s.options.rtl?"left":"right":o<=360&&o>=315?!1===s.options.rtl?"left":"right":o>=135&&o<=225?!1===s.options.rtl?"right":"left":!0===s.options.verticalSwiping?o>=35&&o<=135?"down":"up":"vertical"},e.prototype.swipeEnd=function(i){var e,t,o=this;if(o.dragging=!1,o.swiping=!1,o.scrolling)return o.scrolling=!1,!1;if(o.interrupted=!1,o.shouldClick=!(o.touchObject.swipeLength>10),void 0===o.touchObject.curX)return!1;if(!0===o.touchObject.edgeHit&&o.$slider.trigger("edge",[o,o.swipeDirection()]),o.touchObject.swipeLength>=o.touchObject.minSwipe){switch(t=o.swipeDirection()){case"left":case"down":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide+o.getSlideCount()):o.currentSlide+o.getSlideCount(),o.currentDirection=0;break;case"right":case"up":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide-o.getSlideCount()):o.currentSlide-o.getSlideCount(),o.currentDirection=1}"vertical"!=t&&(o.slideHandler(e),o.touchObject={},o.$slider.trigger("swipe",[o,t]))}else o.touchObject.startX!==o.touchObject.curX&&(o.slideHandler(o.currentSlide),o.touchObject={})},e.prototype.swipeHandler=function(i){var e=this;if(!(!1===e.options.swipe||"ontouchend"in document&&!1===e.options.swipe||!1===e.options.draggable&&-1!==i.type.indexOf("mouse")))switch(e.touchObject.fingerCount=i.originalEvent&&void 0!==i.originalEvent.touches?i.originalEvent.touches.length:1,e.touchObject.minSwipe=e.listWidth/e.options.touchThreshold,!0===e.options.verticalSwiping&&(e.touchObject.minSwipe=e.listHeight/e.options.touchThreshold),i.data.action){case"start":e.swipeStart(i);break;case"move":e.swipeMove(i);break;case"end":e.swipeEnd(i)}},e.prototype.swipeMove=function(i){var e,t,o,s,n,r,l=this;return n=void 0!==i.originalEvent?i.originalEvent.touches:null,!(!l.dragging||l.scrolling||n&&1!==n.length)&&(e=l.getLeft(l.currentSlide),l.touchObject.curX=void 0!==n?n[0].pageX:i.clientX,l.touchObject.curY=void 0!==n?n[0].pageY:i.clientY,l.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(l.touchObject.curX-l.touchObject.startX,2))),r=Math.round(Math.sqrt(Math.pow(l.touchObject.curY-l.touchObject.startY,2))),!l.options.verticalSwiping&&!l.swiping&&r>4?(l.scrolling=!0,!1):(!0===l.options.verticalSwiping&&(l.touchObject.swipeLength=r),t=l.swipeDirection(),void 0!==i.originalEvent&&l.touchObject.swipeLength>4&&(l.swiping=!0,i.preventDefault()),s=(!1===l.options.rtl?1:-1)*(l.touchObject.curX>l.touchObject.startX?1:-1),!0===l.options.verticalSwiping&&(s=l.touchObject.curY>l.touchObject.startY?1:-1),o=l.touchObject.swipeLength,l.touchObject.edgeHit=!1,!1===l.options.infinite&&(0===l.currentSlide&&"right"===t||l.currentSlide>=l.getDotCount()&&"left"===t)&&(o=l.touchObject.swipeLength*l.options.edgeFriction,l.touchObject.edgeHit=!0),!1===l.options.vertical?l.swipeLeft=e+o*s:l.swipeLeft=e+o*(l.$list.height()/l.listWidth)*s,!0===l.options.verticalSwiping&&(l.swipeLeft=e+o*s),!0!==l.options.fade&&!1!==l.options.touchMove&&(!0===l.animating?(l.swipeLeft=null,!1):void l.setCSS(l.swipeLeft))))},e.prototype.swipeStart=function(i){var e,t=this;if(t.interrupted=!0,1!==t.touchObject.fingerCount||t.slideCount<=t.options.slidesToShow)return t.touchObject={},!1;void 0!==i.originalEvent&&void 0!==i.originalEvent.touches&&(e=i.originalEvent.touches[0]),t.touchObject.startX=t.touchObject.curX=void 0!==e?e.pageX:i.clientX,t.touchObject.startY=t.touchObject.curY=void 0!==e?e.pageY:i.clientY,t.dragging=!0},e.prototype.unfilterSlides=e.prototype.slickUnfilter=function(){var i=this;null!==i.$slidesCache&&(i.unload(),i.$slideTrack.children(this.options.slide).detach(),i.$slidesCache.appendTo(i.$slideTrack),i.reinit())},e.prototype.unload=function(){var e=this;i(".slick-cloned",e.$slider).remove(),e.$dots&&e.$dots.remove(),e.$prevArrow&&e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.remove(),e.$nextArrow&&e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.remove(),e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden","true").css("width","")},e.prototype.unslick=function(i){var e=this;e.$slider.trigger("unslick",[e,i]),e.destroy()},e.prototype.updateArrows=function(){var i=this;Math.floor(i.options.slidesToShow/2),!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&!i.options.infinite&&(i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false"),0===i.currentSlide?(i.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-i.options.slidesToShow&&!1===i.options.centerMode?(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-1&&!0===i.options.centerMode&&(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")))},e.prototype.updateDots=function(){var i=this;null!==i.$dots&&(i.$dots.find("li").removeClass("slick-active").end(),i.$dots.find("li").eq(Math.floor(i.currentSlide/i.options.slidesToScroll)).addClass("slick-active"))},e.prototype.visibility=function(){var i=this;i.options.autoplay&&(document[i.hidden]?i.interrupted=!0:i.interrupted=!1)},i.fn.slick=function(){var i,t,o=this,s=arguments[0],n=Array.prototype.slice.call(arguments,1),r=o.length;for(i=0;i<r;i++)if("object"==typeof s||void 0===s?o[i].slick=new e(o[i],s):t=o[i].slick[s].apply(o[i].slick,n),void 0!==t)return t;return o}});
/* MODAL */
!function(t,o){"function"==typeof define&&define.amd?define(o):"object"==typeof exports?module.exports=o():t.tingle=o()}(this,function(){var t=!1;function o(t){this.opts=function t(){for(var o=1;o<arguments.length;o++)for(var e in arguments[o])arguments[o].hasOwnProperty(e)&&(arguments[0][e]=arguments[o][e]);return arguments[0]}({},{onClose:null,onOpen:null,beforeOpen:null,beforeClose:null,stickyFooter:!1,footer:!1,cssClass:[],closeLabel:"Close",closeMethods:["overlay","button","escape"]},t),this.init()}function e(){this.modalBoxFooter&&(this.modalBoxFooter.style.width=this.modalBox.clientWidth+"px",this.modalBoxFooter.style.left=this.modalBox.offsetLeft+"px")}function s(){this.modal=document.createElement("div"),this.modal.classList.add("tingle-modal"),(0===this.opts.closeMethods.length||-1===this.opts.closeMethods.indexOf("overlay"))&&this.modal.classList.add("tingle-modal--noOverlayClose"),this.modal.style.display="none",this.opts.cssClass.forEach(function(t){"string"==typeof t&&this.modal.classList.add(t)},this),-1!==this.opts.closeMethods.indexOf("button")&&(this.modalCloseBtn=document.createElement("button"),this.modalCloseBtn.type="button",this.modalCloseBtn.classList.add("tingle-modal__close"),this.modalCloseBtnIcon=document.createElement("span"),this.modalCloseBtnIcon.classList.add("tingle-modal__closeIcon"),this.modalCloseBtnIcon.innerHTML='<i class="i i-xmark2"></i>',this.modalCloseBtnLabel=document.createElement("span"),this.modalCloseBtnLabel.classList.add("tingle-modal__closeLabel"),this.modalCloseBtnLabel.innerHTML=this.opts.closeLabel,this.modalCloseBtn.appendChild(this.modalCloseBtnIcon),this.modalCloseBtn.appendChild(this.modalCloseBtnLabel)),this.modalBox=document.createElement("div"),this.modalBox.classList.add("tingle-modal-box"),this.modalBoxContent=document.createElement("div"),this.modalBoxContent.classList.add("tingle-modal-box__content"),this.modalBox.appendChild(this.modalBoxContent),-1!==this.opts.closeMethods.indexOf("button")&&this.modal.appendChild(this.modalCloseBtn),this.modal.appendChild(this.modalBox)}function i(){this.modalBoxFooter=document.createElement("div"),this.modalBoxFooter.classList.add("tingle-modal-box__footer"),this.modalBox.appendChild(this.modalBoxFooter)}function l(){this._events={clickCloseBtn:this.close.bind(this),clickOverlay:a.bind(this),resize:this.checkOverflow.bind(this),keyboardNav:n.bind(this)},-1!==this.opts.closeMethods.indexOf("button")&&this.modalCloseBtn.addEventListener("click",this._events.clickCloseBtn),this.modal.addEventListener("mousedown",this._events.clickOverlay),window.addEventListener("resize",this._events.resize),document.addEventListener("keydown",this._events.keyboardNav)}function n(t){-1!==this.opts.closeMethods.indexOf("escape")&&27===t.which&&this.isOpen()&&this.close()}function a(t){var o=this.modal.offsetWidth-this.modal.clientWidth,e=t.clientX>=this.modal.offsetWidth-15,s=this.modal.scrollHeight!==this.modal.offsetHeight;("MacIntel"!==navigator.platform||0!==o||!e||!s)&&-1!==this.opts.closeMethods.indexOf("overlay")&&!function t(o,e){for(;(o=o.parentElement)&&!o.classList.contains(e););return o}(t.target,"tingle-modal")&&t.clientX<this.modal.clientWidth&&this.close()}function d(){-1!==this.opts.closeMethods.indexOf("button")&&this.modalCloseBtn.removeEventListener("click",this._events.clickCloseBtn),this.modal.removeEventListener("mousedown",this._events.clickOverlay),window.removeEventListener("resize",this._events.resize),document.removeEventListener("keydown",this._events.keyboardNav)}return o.prototype.init=function(){if(!this.modal)return s.call(this),l.call(this),document.body.appendChild(this.modal,document.body.firstChild),this.opts.footer&&this.addFooter(),this},o.prototype._busy=function(o){t=o},o.prototype._isBusy=function(){return t},o.prototype.destroy=function(){null!==this.modal&&(this.isOpen()&&this.close(!0),d.call(this),this.modal.parentNode.removeChild(this.modal),this.modal=null)},o.prototype.isOpen=function(){return!!this.modal.classList.contains("tingle-modal--visible")},o.prototype.open=function(){if(!this._isBusy())return this._busy(!0),"function"==typeof this.opts.beforeOpen&&this.opts.beforeOpen(),this.modal.style.removeProperty?this.modal.style.removeProperty("display"):this.modal.style.removeAttribute("display"),document.getSelection().removeAllRanges(),this._scrollPosition=window.pageYOffset,document.body.classList.add("tingle-enabled"),document.body.style.top=-this._scrollPosition+"px",this.setStickyFooter(this.opts.stickyFooter),this.modal.classList.add("tingle-modal--visible"),"function"==typeof this.opts.onOpen&&this.opts.onOpen.call(this),this._busy(!1),this.checkOverflow(),this},o.prototype.close=function(t){if(!this._isBusy()){if(this._busy(!0),t=t||!1,"function"==typeof this.opts.beforeClose&&!this.opts.beforeClose.call(this)){this._busy(!1);return}document.body.classList.remove("tingle-enabled"),document.body.style.top=null,window.scrollTo({top:this._scrollPosition,behavior:"instant"}),this.modal.classList.remove("tingle-modal--visible");var o=this;o.modal.style.display="none","function"==typeof o.opts.onClose&&o.opts.onClose.call(this),o._busy(!1)}},o.prototype.setContent=function(t){return"string"==typeof t?this.modalBoxContent.innerHTML=t:(this.modalBoxContent.innerHTML="",this.modalBoxContent.appendChild(t)),this.isOpen()&&this.checkOverflow(),this},o.prototype.getContent=function(){return this.modalBoxContent},o.prototype.addFooter=function(){return i.call(this),this},o.prototype.setFooterContent=function(t){return this.modalBoxFooter.innerHTML=t,this},o.prototype.getFooterContent=function(){return this.modalBoxFooter},o.prototype.setStickyFooter=function(t){return this.isOverflow()||(t=!1),t?(this.modalBox.contains(this.modalBoxFooter)&&(this.modalBox.removeChild(this.modalBoxFooter),this.modal.appendChild(this.modalBoxFooter),this.modalBoxFooter.classList.add("tingle-modal-box__footer--sticky"),e.call(this)),this.modalBoxContent.style["padding-bottom"]=this.modalBoxFooter.clientHeight+20+"px"):this.modalBoxFooter&&!this.modalBox.contains(this.modalBoxFooter)&&(this.modal.removeChild(this.modalBoxFooter),this.modalBox.appendChild(this.modalBoxFooter),this.modalBoxFooter.style.width="auto",this.modalBoxFooter.style.left="",this.modalBoxContent.style["padding-bottom"]="",this.modalBoxFooter.classList.remove("tingle-modal-box__footer--sticky")),this},o.prototype.addFooterBtn=function(t,o,e){var s=document.createElement("button");return s.innerHTML=t,s.addEventListener("click",e),"string"==typeof o&&o.length&&o.split(" ").forEach(function(t){s.classList.add(t)}),this.modalBoxFooter.appendChild(s),s},o.prototype.resize=function(){console.warn("Resize is deprecated and will be removed in version 1.0")},o.prototype.isOverflow=function(){var t=window.innerHeight;return this.modalBox.clientHeight>=t},o.prototype.checkOverflow=function(){this.modal.classList.contains("tingle-modal--visible")&&(this.isOverflow()?this.modal.classList.add("tingle-modal--overflow"):this.modal.classList.remove("tingle-modal--overflow"),!this.isOverflow()&&this.opts.stickyFooter?this.setStickyFooter(!1):this.isOverflow()&&this.opts.stickyFooter&&(e.call(this),this.setStickyFooter(!0)))},{modal:o}});
function loadScript( url, callback ) {
    var script = document.createElement( "script" )
    script.type = "text/javascript";
    if(script.readyState) {  // only required for IE <9
      script.onreadystatechange = function() {
        if ( script.readyState === "loaded" || script.readyState === "complete" ) {
          script.onreadystatechange = null;
          callback();
        }
      };
    } else {  //Others
      script.onload = function() {
        callback();
      };
    }

    script.src = url;
    document.getElementsByTagName( "head" )[0].appendChild( script );
}
(function(e,g){"object"===typeof exports&&"undefined"!==typeof module?module.exports=g():"function"===typeof define&&define.amd?define(g):(e=e||self,e.currencyc=g())})(this,function(){function e(b,a){if(!(this instanceof e))return new e(b,a);a=Object.assign({},m,a);var d=Math.pow(10,a.precision);this.intValue=b=g(b,a);this.value=b/d;a.increment=a.increment||1/d;a.groups=a.useVedic?n:p;this.s=a;this.p=d}function g(b,a){var d=2<arguments.length&&void 0!==arguments[2]?arguments[2]:!0;var c=a.decimal;
		var h=a.errorOnInvalid,k=a.fromCents,l=Math.pow(10,a.precision),f=b instanceof e;if(f&&k)return b.intValue;if("number"===typeof b||f)c=f?b.value:b;else if("string"===typeof b)h=new RegExp("[^-\\d"+c+"]","g"),c=new RegExp("\\"+c,"g"),c=(c=b.replace(/\((.*)\)/,"-$1").replace(h,"").replace(c,"."))||0;else{if(h)throw Error("Invalid Input");c=0}k||(c=(c*l).toFixed(4));return d?Math.round(c):c}var m={symbol:"$",separator:",",decimal:".",errorOnInvalid:!1,precision:2,pattern:"!#",negativePattern:"-!#",format:function(b,
		a){var d=a.pattern,c=a.negativePattern,h=a.symbol,k=a.separator,l=a.decimal;a=a.groups;var f=(""+b).replace(/^-/,"").split("."),q=f[0];f=f[1];return(0<=b.value?d:c).replace("!",h).replace("#",q.replace(a,"$1"+k)+(f?l+f:""))},fromCents:!1},p=/(\d)(?=(\d{3})+\b)/g,n=/(\d)(?=(\d\d)+\d\b)/g;e.prototype={add:function(b){var a=this.s,d=this.p;return e((this.intValue+g(b,a))/(a.fromCents?1:d),a)},subtract:function(b){var a=this.s,d=this.p;return e((this.intValue-g(b,a))/(a.fromCents?1:d),a)},multiply:function(b){var a=
		this.s;return e(this.intValue*b/(a.fromCents?1:Math.pow(10,a.precision)),a)},divide:function(b){var a=this.s;return e(this.intValue/g(b,a,!1),a)},distribute:function(b){var a=this.intValue,d=this.p,c=this.s,h=[],k=Math[0<=a?"floor":"ceil"](a/b),l=Math.abs(a-k*b);for(d=c.fromCents?1:d;0!==b;b--){var f=e(k/d,c);0<l--&&(f=f[0<=a?"add":"subtract"](1/d));h.push(f)}return h},dollars:function(){return~~this.value},cents:function(){return~~(this.intValue%this.p)},format:function(b){var a=this.s;return"function"===
		typeof b?b(this,a):a.format(this,Object.assign({},a,b))},toString:function(){var b=this.s,a=b.increment;return(Math.round(this.intValue/this.p/a)*a).toFixed(b.precision)},toJSON:function(){return this.value}};return e});
function get_nice_price(value, cur){
    //console.log("value:"+  value + " cur: "+cur);
    precision_digits = 0;
    if( currencyc(value).cents() != "0" ){
        precision_digits = 0;
    }
    switch(cur) {
        case "USD":
            value = Math.ceil(value);
            var nice_price = value => currencyc(value, { pattern: "!#", symbol: '$', decimal: '.', separator: ',', precision: precision_digits });
            break;
        case "SGD":
            value = Math.ceil(value);
            var nice_price = value => currencyc(value, { pattern: "S!#", symbol: '$', decimal: '.', separator: ',', precision: precision_digits });
            break;
        case "MXN":
            value = Math.ceil(value);
            var nice_price = value => currencyc(value, { pattern: "MX!#", symbol: '$', decimal: '.', separator: ',', precision: precision_digits });
            break;
        case "TWD":
            value = Math.ceil(value);
            var nice_price = value => currencyc(value, { pattern: "NT!#", symbol: '$', decimal: '.', separator: ',', precision: precision_digits });
            break;
        case "CHF":
            value = Math.ceil(value);
            var nice_price = value => currencyc(value, { pattern: "CHF !#", symbol: '', decimal: '.', separator: '', precision: precision_digits });
            break;
        case "GBP":
            value = Math.ceil(value);
            var nice_price = value => currencyc(value, { pattern: "!#", symbol: '£', decimal: '.', separator: ',', precision: precision_digits });
            break;
        case "CAD":
            value = Math.ceil(value);
            var nice_price = value => currencyc(value, { pattern: "CA!#", symbol: '$', decimal: '.', separator: ',', precision: precision_digits });
            break;
        case "JPY":
            value = Math.ceil(value / 100) * 100;
            var nice_price = value => currencyc(value, { pattern: "!#", symbol: '¥', decimal: '.', separator: ',', precision: precision_digits });
            break;
        case "AUD":
            value = Math.ceil(value);
            var nice_price = value => currencyc(value, { pattern: "A!#", symbol: '$', decimal: '.', separator: ',', precision: precision_digits });
            break;
        case "EUR":
            value = Math.ceil(value);
            value = String(value).replace('.', ',');
            var nice_price = value => currencyc(value, { pattern: "# !", symbol: '€', decimal: ',', separator: '.', precision: precision_digits });
            break;
        case "HKD":
            value = Math.ceil(value);
            var nice_price = value => currencyc(value, { pattern: "HK!#", symbol: '$', decimal: '.', separator: ',', precision: precision_digits });
            break;
        default:
        var nice_price = value => currencyc(value, { pattern: "# !", symbol: '$', decimal: ',', separator: '.', precision: precision_digits });
    }
    return nice_price(value).format();
}
jQuery('.reviews-sliderI').slick({
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 5000,
    centerPadding: '60px',
    appendArrows: ".reviews-SliderArrows",
    prevArrow: "<i class='i i-long-arrow-left'></i>",
    nextArrow: "<i class='i i-long-arrow-right'></i>",
    responsive: [
        {
        breakpoint: 2200,
        settings: {
            slidesToShow: 5
            }
        },
        {
        breakpoint: 1750,
        settings: {
            slidesToShow: 4
            }
        },
        {
        breakpoint: 1500,
        settings: {
            slidesToShow: 3
            }
        },
        {
        breakpoint: 1024,
        settings: {
            slidesToShow: 2
            }
        },
        {
        breakpoint: 800,
        settings: {
            centerMode: false,
            arrows: true,
            slidesToShow: 1,
            dots: false,
            autoplay: false
            }
        }
    ]
});
function getVariantDetails(productJson, variantId) {
    for (var i = 0; i < productJson.variants.length; i++) {
        var variant = productJson.variants[i];        
        if (variant.id === variantId) {
            return variant;
        }
    }
    return null;
}

jQuery(".infinite_video_slider").each(function(e){
  var id = jQuery(this).data("id");
  var main_slider = "#infinite_video_sliderI"+id;
  console.log("initializing for " + main_slider);
  jQuery(main_slider).slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        speed: 500,
        appendArrows: "#infinite_video_slider_arrows"+id,
        prevArrow: "<i class='i i-long-arrow-left'></i>",
        nextArrow: "<i class='i i-long-arrow-right'></i>",
        responsive: [
            {
                breakpoint: 1750,
                settings: {
                    slidesToShow: 2
                    }
            },
            {
              breakpoint: 1024,
              settings: {
                arrows: true,
                slidesToShow: 1
              }
            }
          ]
  });
});

jQuery(".infinite_video_product_slider").each(function(e){
  var id = jQuery(this).data("id");
  var main_slider = "#infinite_video_product_sliderI"+id;
  console.log("initializing for " + main_slider);
  jQuery(main_slider).slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        speed: 500,
        appendArrows: "#infinite_video_product_slider_arrows"+id,
        prevArrow: "<i class='i i-long-arrow-left'></i>",
        nextArrow: "<i class='i i-long-arrow-right'></i>",
        responsive: [
            {
                breakpoint: 1750,
                settings: {
                    slidesToShow: 3
                    }
            },
            {
              breakpoint: 1024,
              settings: {
                arrows: true,
                slidesToShow: 1
              }
            }
          ]
  });
});


if (jQuery(window).width() <= 768) {
  jQuery(".in_the_pressW").each(function(e){
    var id = jQuery(this).data("id");
    var main_slider = "#in_the_pressI"+id;
     jQuery(main_slider).slick({
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: false,
          arrows: true,
          speed: 500,
          appendArrows: "#in_the_pressI_slider_arrows"+id,
          prevArrow: "<i class='i i-long-arrow-left'></i>",
          nextArrow: "<i class='i i-long-arrow-right'></i>",
          responsive: [
              {
                  breakpoint: 1750,
                  settings: {
                      slidesToShow: 2
                      }
              },
              {
                breakpoint: 1024,
                settings: {
                  arrows: true,
                  slidesToShow: 1
                }
              }
            ]
    });
  });
}


jQuery("body").on("click",".sliderVideo", function(e){
  var modal = new tingle.modal({
      footer: false,
      stickyFooter: false,
      closeMethods: ['overlay', 'button', 'escape'],
      closeLabel: "Close",
      cssClass: ['custom-class-1', 'custom-class-2'],
      onOpen: function() {},
      onClose: function() { modal.destroy(); },
      beforeClose: function() {
          return true; // close the modal
          return false; // nothing happens
      }
  }); 
  var content = "<div class='responsive-embed widescreen'><iframe width='100%' height='auto' src='https://www.youtube.com/embed/"+jQuery(this).data("video_id")+"?controls=0' title='ouTube video player' frameborder='0' allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture' allowfullscreen></iframe></div>";
  modal.setContent(content);
  modal.open();  
  //modal.close();
});

jQuery("body").on("click",".sliderVideoC", function(e){
  var modal = new tingle.modal({
      footer: false,
      stickyFooter: false,
      closeMethods: ['overlay', 'button', 'escape'],
      closeLabel: "Close",
      cssClass: ['custom-class-1', 'custom-class-2'],
      onOpen: function() {},
      onClose: function() { modal.destroy(); },
      beforeClose: function() {
          return true; // close the modal
          return false; // nothing happens
      }
  }); 
  var content = "<div class='responsive-embed vertical'><video width='1080' height='1920' controls><source src="+jQuery(this).data("video_id")+" type='video/mp4'></video></div>";
  modal.setContent(content);
  modal.open();  
  //modal.close();
});

jQuery(".slider_image_v1").each(function(e){
  var id = jQuery(this).data("id");
  var main_slider = jQuery("#slider_image_v1_IMGs"+id);
  var nav_slider = jQuery("#slider_image_v1_nav"+id);
  main_slider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '#slider_image_v1_nav'+id
  });
  nav_slider.slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '#slider_image_v1_IMGs'+id,
    dots: false,
    centerMode: false,
    focusOnSelect: true,
    appendArrows: "#slider_image_v1_arrows"+id,
    prevArrow: "<i class='i i-long-arrow-left'></i>",
    nextArrow: "<i class='i i-long-arrow-right'></i>",
  });
  
});
jQuery(".slider_image_v2").each(function(e){
  var id = jQuery(this).data("id");
  var main_slider = jQuery("#slider_image_v2_IMGs"+id);
  var nav_slider = jQuery("#slider_image_v2_nav"+id);
  main_slider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '#slider_image_v2_nav'+id
  });
  nav_slider.slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '#slider_image_v2_IMGs'+id,
    dots: false,
    centerMode: false,
    focusOnSelect: true,
    appendArrows: "#slider_image_v2_arrows"+id,
    prevArrow: "<i class='i i-long-arrow-left'></i>",
    nextArrow: "<i class='i i-long-arrow-right'></i>",
  });
  
});
jQuery(".find_your_lookW").each(function(e){
  var id = jQuery(this).data("id");
  var main_slider = jQuery("#find_your_look_IMGs"+id);
  var nav_slider = jQuery("#find_your_look_nav"+id);
  main_slider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: "#find_your_look_nav"+id
  });
  nav_slider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: "#find_your_look_IMGs"+id,
    dots: false,
    centerMode: false,
    focusOnSelect: true,
    appendArrows: "#find_your_look_arrows"+id,
    prevArrow: "<i class='i i-long-arrow-left'></i>",
    nextArrow: "<i class='i i-long-arrow-right'></i>",
  });
});
jQuery('.musicianSliderI').slick({
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 5000,
    centerPadding: '60px',
    appendArrows: ".musicianSlider-Arrows",
    prevArrow: "<i class='i i-long-arrow-left'></i>",
    nextArrow: "<i class='i i-long-arrow-right'></i>",
    responsive: [
        {
        breakpoint: 2200,
        settings: {
            slidesToShow: 5
            }
        },
        {
        breakpoint: 1750,
        settings: {
            slidesToShow: 4
            }
        },
        {
        breakpoint: 1500,
        settings: {
            slidesToShow: 3
            }
        },
        {
        breakpoint: 1024,
        settings: {
            slidesToShow: 2
            }
        },
        {
        breakpoint: 800,
        settings: {
            centerMode: false,
            arrows: true,
            slidesToShow: 1,
            dots: false,
            autoplay: false
            }
        }
    ]
});
jQuery('.wbtbSliderI').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 5000,
    centerPadding: '60px',
    appendArrows: ".wbtbSlider-Arrows",
    prevArrow: "<i class='i i-long-arrow-left'></i>",
    nextArrow: "<i class='i i-long-arrow-right'></i>",
    responsive: [
        {
        breakpoint: 1920,
        settings: {
            slidesToShow: 3
            }
        },
        {
        breakpoint: 1024,
        settings: {
            slidesToShow: 2
            }
        },
        {
        breakpoint: 800,
        settings: {
            centerMode: false,
            arrows: true,
            slidesToShow: 1,
            dots: false,
            autoplay: false
            }
        }
    ]
});
jQuery('#compareTable').slick({
  infinite: false,
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: false,
  appendArrows: ".compareSlider-Arrows",
  prevArrow: "<i class='i i-long-arrow-left'></i>",
  nextArrow: "<i class='i i-long-arrow-right'></i>",
  responsive: [
    {
      breakpoint: 1000,
      settings: {
        slidesToShow: 2,
        arrows: true,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        infinite: false,
        slidesToShow: 2,
        arrows: true,
        slidesToScroll: 1
      }
    }
  ]
});
function countdown(timetocount, element_id){
    var e =  document.getElementById(element_id);
    if (typeof(e) != 'undefined' && e != null){
        var countDownDate = new Date(timetocount).getTime();
        var x = setInterval(function() {
            var now = new Date().getTime();

            var distance = countDownDate - now;

            var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);
            if( days > 6){
              return false;
            }
            if(days < 10 && days >= 0){
                strdays = '0' + days;
            } else {
                strdays = days;
            }
            if(hours < 10 && hours >= 0){
                strhours = '0' + hours;
            } else {
                strhours = hours;
            }
            if(minutes < 10 && minutes >= 0){
                strminutes = '0' + minutes;
            } else {
                strminutes = minutes;
            }
            if(seconds < 10 && seconds > 0){
                strseconds = '0' + seconds;
            } else {
                strseconds = seconds;
            }
            e.innerHTML = "<div class='offerT'><span class='offerTBig'>" + strdays + "</span><span class='offerTSmall'> days </span></div><div class='offerT'><span class='offerTBig'>" + strhours + "</span><span class='offerTSmall'> hours </span></div><div class='offerT'><span class='offerTBig'>" + strminutes + "</span><span class='offerTSmall'> mins </span></div><div class='offerT'><span class='offerTBig'>" + strseconds + "</span><span class='offerTSmall'> secs</span></div>";
            if (distance < 0) {
                clearInterval(x);
                e.style.display = "none";
              jQuery(".stikyBTxt").removeClass("timer");
            }else{
              //e.style.display = "block";
              document.getElementById("shopify-section-announcement-bar").classList.add("timerActive");
              document.getElementById("stikyBTxt2").classList.add("timer");
              document.documentElement.classList.add("stickyTimerActive");
            }
        }, 1000);
    }
}
function timed_offer(element_id){
    var cdate = document.getElementById(element_id).getAttribute('data-expire');
    var d = new Date(cdate);
    var localTime = d.getTime();
    var offset = -8;
    var localOffsetHours = d.getTimezoneOffset() / 60;
    var tdif = localOffsetHours + offset;
    var localOffset = d.getTimezoneOffset() * 60000;
    var utc = localTime + localOffset;
    var time_to_promo_end = localTime - (60 * 60 * 1000 * tdif);
    countdown(time_to_promo_end, element_id);
}
//INITIALIZE COUNTDOWN FOR STICKY BANNER
var element = document.getElementById('offerCountDown');
if (element) { 
    timed_offer("offerCountDown");
}
//FOOTER SHOW/HIDE submenu
var e = document.querySelectorAll('.mfh3');
e.forEach(function(e) {
    e.addEventListener('click', function(e) {
        this.parentNode.classList.toggle('active');
    });
});

function shopify_image_size(filename, string){
    var dotIndex = filename.lastIndexOf(".");
    if (dotIndex == -1) return filename + string;
    else return filename.substring(0, dotIndex) + string + filename.substring(dotIndex);
} 
function prepare_product_images_for_display(product_images){
    image_sizes = {
        "w120": "_120x120_crop_center",//used for upsell
        "w270": "_270x270_crop_center",//used for shop
        "w348": "_348x348_crop_center",
        "w600": "_600x600_crop_center",
        "w700": "_700x700_crop_center",
        "w800": "_800x800_crop_center",
        "w1000": "_1000x1000_crop_center"
    };
    final_images = {
        "imgs": [],
        "hover": [],
        "shop": []
    }
    for (const property in image_sizes) {
        final_images.hover[property] 	= shopify_image_size(product_images.hover, image_sizes[property]);
        final_images.shop[property] 	= shopify_image_size(product_images.shop, image_sizes[property]);
    }
    for(i=0; i < product_images.images.length; i++){
         if (typeof final_images.imgs[i] === 'undefined') {
            final_images.imgs[i] = {};
        }
        for (const property in image_sizes) {         
            final_images.imgs[i][property] = shopify_image_size(product_images.images[i], image_sizes[property]);
        }
    }
    return final_images;
}
function product_details_add_imgs(product_images){
    var $carousel = jQuery("#slider-shop-bannerIMGS");
    if ($carousel.hasClass('slick-initialized')) {
        $carousel.slick('unslick');
    }
    var $carouselM = jQuery("#slider-shop-bannerIMGSm");
    if ($carouselM.hasClass('slick-initialized')) {
        $carouselM.slick('unslick');
    }
    jQuery("#slider-shop-bannerIMGS").empty();
    jQuery("#slider-shop-bannerIMGSm").empty();
    for(i=0;i<product_images.imgs.length; i++){
        jQuery("#slider-shop-bannerIMGS").append("<div><img src='"+product_images.imgs[i].w800+"' width='800' height='800' alt='"+product_images.imgs[i].altText+" - image nr "+i+"'></div>");
        jQuery("#slider-shop-bannerIMGSm").append("<div><img src='"+product_images.imgs[i].w600+"' width='600' height='600' alt='"+product_images.imgs[i].altText+" - image nr "+i+"'></div>");

    }
}
function get_images_from_product_graphql(product_images, variations){
      //console.log(variations);
      //console.log(product_images);
      var vimages = [];
      for(var i = 0; i < variations.length; i++) {
          if( variations[i].featured_image == null ) continue;
          if( variations[i].featured_image.src.toLowerCase().includes("_shop")){

          }else{
              vimages.push(variations[i].featured_image);
          }			
      }
      //console.log("Var images:");
      //console.log(vimages);
      var images = { "images": [], "hover": false, "shop": false};
      //product_images.edges.forEach(image => {
      for(var i = 0; i < product_images.length; i++) {
          img = product_images[i];
          if( vimages.includes(img) ){
              //do nothing
          }else{
              if( img.toLowerCase().includes("_hover") ){
                  images.hover = img;
              }else if( img.toLowerCase().includes("_shop") ){
                  images.shop = img;
              }else{
                  images.images.push(img);
              }
          }
      };
      if( images.images.length == 0){
          images.images.push(variations.edges[0].node.image);
      }
      if( images.hover == false){
          j = 1;
          if( images.images[1] == null){ j=0; }
          images.hover = images.images[j];
      }
      if( images.shop == false){
          images.shop = images.images[0];
      }
      //console.log(images);
      images = prepare_product_images_for_display(images);
      return images;        
}
function product_details_imgs_slider(){
    var $carousel = jQuery("#slider-shop-bannerIMGS");
    if ($(window).width() < 768) {
        var $carousel = jQuery("#slider-shop-bannerIMGSm");
        $carousel.slick({
            dots: true,
            arrows: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 500,
            mobileFirst: true
        });
    }else{
        var $carousel = jQuery("#slider-shop-bannerIMGS");
        jQuery('#slider-shop-bannerIMGS').slick({
            rows: 2,
            slidesPerRow: 2,
            dots: false,
            arrows: true,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 500,
            prevArrow: "<div class='sArrow sPrev'><i class='i i-long-arrow-left'></i></div>",
            nextArrow: "<div class='sArrow sNext'><i class='i i-long-arrow-right'></i></div>"
        });
    }
}
function updateShippingSideCart(shippingData, dynamic_cart = false ){
    if( shippingData === false){shippingData = getShippingData2(); console.log(shippingData) }
    var discountData = JSON.parse($('#sideCartDiscountMsg').html());
    console.log(shippingData);
    console.log("dynamic_cart "+ dynamic_cart );
    if( dynamic_cart === false){
      dynamic_cart = jQuery("#cartPop .discountApp").data("cart_total");
    }
    //var msg = "Easter Sale: <span class='c_discount-percentage'></span> off applied!";
    var msg = discountData.side_cart_discount_default;
    let free_shipping = shippingData.freeShippingThresholdRaw * 100;
    let findR = {};
    findR["c_discount-percentage"] = shippingData.discountPercentage + "%";
    console.log( "free shipping at" + free_shipping );
    console.log( "dynamic_cart" + dynamic_cart );
    if( shippingData.freeShippingAvailable ){
      if( free_shipping < dynamic_cart ){
        //msg = "Easter Sale: <span class='c_discount-percentage'></span> off & <span class='pmBol'>free shipping</span> applied!";    
        msg = discountData.side_cart_discount_free_shipping;
      }else{
        var progress_barW = "<div class='hProgressBar'><div style='width:" + Math.min(100, (dynamic_cart / free_shipping) * 100) + "%;'></div></div>";
        //msg = "Easter Sale: <span class='c_discount-percentage'></span> off applied!<br/>You are <span class='c_FreeShippingThresholdLeft'></span> away from <span class='pmBol'>free shipping</span>. <span class='c_FreeShippingProgressBar'></span>";
        msg = discountData.side_cart_discount_shipping_threshold;
        findR["c_FreeShippingThresholdLeft"] = get_nice_price( Math.ceil( ( free_shipping - dynamic_cart ) / 100), jQuery("body").data("currency_iso"));
        findR["c_FreeShippingProgressBar"] = progress_barW;
      }
    }
    jQuery("#cartPopDiscountAppTxt").html(msg);
     jQuery.each(findR, function(key, value) {
      if (value !== false && value !== undefined) {
        jQuery("#cartPopDiscountAppTxt").find("." + key).html(value);
      }
    });
    //DISPLAY TAXES FOR COUNTRY
    if( shippingData.taxIncluded ){
      jQuery("#cartPageTax").html("Included in price");
    }else{
      jQuery("#cartPageTax").html("May be due on delivery");
    }
    //DISPLAY SHIPPING TIME FOR COUNTRY
    jQuery("#cartPopFooter .shippingTime").html( "<i class='i i-box_2'></i> " + shippingData.shippingMessage);
}
function addToCart(products) {
    var modal = new tingle.modal({
        footer: false,
        stickyFooter: false,
        closeMethods: ['overlay', 'button', 'escape'],
        closeLabel: "Close",
        cssClass: ['tingle_modal_atc', 'custom-class-2'],
        onOpen: function() {},
        onClose: function() { modal.destroy(); },
        beforeClose: function() {
            return true; // close the modal
            return false; // nothing happens
        }
    }); 
    modal.setContent('<div id="loadingCIcon"></div><div id="loadingCTxt">Adding product to your cart, please wait</div>');
    modal.open();  
    let chain = Promise.resolve();

    products.forEach(product => {
        chain = chain.then(() => {
            return fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Accept': 'application/json'
                },
                body: new URLSearchParams({
                    quantity: product.quantity,
                    id: product.id
                })
            }).then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            });
        });
    });

    chain
        .then(() => {
            // Fetch the entire updated cart
            return fetch('/cart.js', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
        })
        .then(cart => {
            console.log('Products added to cart:', cart);
            var _learnq = _learnq || [];
            _learnq.push(['track', 'Added to Cart', cart]);
            // After adding the products, update the side cart
            updateSideCart(cart);
            modal.close();
            jQuery("#cartPop").addClass("active");
            //jQuery("body").addClass("tingle-enabled").append('<div id="sideCartOverlay" class="tingle-modal custom-class-1 custom-class-2 tingle-modal--visible"></div>');.
            jQuery("body").addClass("tingle-enabled");
            if (jQuery("#sideCartOverlay").length === 0) {
                jQuery("body").append('<div id="sideCartOverlay" class="tingle-modal custom-class-1 custom-class-2 tingle-modal--visible"></div>');
            }
        })
        .catch(error => {
            console.log('Error adding products to cart:', error);
        });
}

function removeFromCart(itemId) {
    fetch('/cart/change.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Accept': 'application/json'
        },
        body: new URLSearchParams({
            id: itemId,
            quantity: 0
        })
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.json();
    })
    .then(cart => {
        console.log('Item removed from cart:', cart);
        // After removing the item, update the side cart
        updateSideCart(cart);
    })
    .catch(error => {
        console.log('Error removing item from cart:', error);
    });
}

function updateCartItemsNR(nr){
  jQuery("#cartQnr").html(nr);
  if(nr > 0 ){
    jQuery("#nav-item-cart").addClass('active');
  }else{
    jQuery("#nav-item-cart").removeClass('active');
  }
}
function getMainProduct(){
      var e =  document.getElementById("mainProductJSON");
        if (e) {
          return JSON.parse(e.textContent || e.innerText);          
        }
        return false;
}
/*##########   COUNTRIES   ##########*/
  function findCountryByCode(data, targetCountryCode) {
      for (let obj of data) {
          if (obj.countryCode === targetCountryCode) {
              return obj; // Return the object if countryCode matches
          }
      }
      return false; // Return false if no match is found
  }
  const countries = {
      "AF": "Afghanistan",
      "AL": "Albania",
      "DZ": "Algeria",
      "AS": "American Samoa",
      "AD": "Andorra",
      "AO": "Angola",
      "AI": "Anguilla",
      "AQ": "Antarctica",
      "AG": "Antigua and Barbuda",
      "AR": "Argentina",
      "AM": "Armenia",
      "AW": "Aruba",
      "AU": "Australia",
      "AT": "Austria",
      "AZ": "Azerbaijan",
      "BS": "Bahamas",
      "BH": "Bahrain",
      "BD": "Bangladesh",
      "BB": "Barbados",
      "BY": "Belarus",
      "BE": "Belgium",
      "BZ": "Belize",
      "BJ": "Benin",
      "BM": "Bermuda",
      "BT": "Bhutan",
      "BO": "Bolivia",
      "BQ": "Bonaire, Sint Eustatius and Saba",
      "BA": "Bosnia and Herzegovina",
      "BW": "Botswana",
      "BV": "Bouvet Island",
      "BR": "Brazil",
      "IO": "British Indian Ocean Territory",
      "BN": "Brunei Darussalam",
      "BG": "Bulgaria",
      "BF": "Burkina Faso",
      "BI": "Burundi",
      "CV": "Cabo Verde",
      "KH": "Cambodia",
      "CM": "Cameroon",
      "CA": "Canada",
      "KY": "Cayman Islands",
      "CF": "Central African Republic",
      "TD": "Chad",
      "CL": "Chile",
      "CN": "China",
      "CX": "Christmas Island",
      "CC": "Cocos (Keeling) Islands",
      "CO": "Colombia",
      "KM": "Comoros",
      "CG": "Congo",
      "CD": "Congo (Democratic Republic of the)",
      "CK": "Cook Islands",
      "CR": "Costa Rica",
      "CI": "Côte d'Ivoire",
      "HR": "Croatia",
      "CU": "Cuba",
      "CW": "Curaçao",
      "CY": "Cyprus",
      "CZ": "Czechia",
      "DK": "Denmark",
      "DJ": "Djibouti",
      "DM": "Dominica",
      "DO": "Dominican Republic",
      "EC": "Ecuador",
      "EG": "Egypt",
      "SV": "El Salvador",
      "GQ": "Equatorial Guinea",
      "ER": "Eritrea",
      "EE": "Estonia",
      "SZ": "Eswatini",
      "ET": "Ethiopia",
      "FK": "Falkland Islands (Malvinas)",
      "FO": "Faroe Islands",
      "FJ": "Fiji",
      "FI": "Finland",
      "FR": "France",
      "GF": "French Guiana",
      "PF": "French Polynesia",
      "TF": "French Southern Territories",
      "GA": "Gabon",
      "GM": "Gambia",
      "GE": "Georgia",
      "DE": "Germany",
      "GH": "Ghana",
      "GI": "Gibraltar",
      "GR": "Greece",
      "GL": "Greenland",
      "GD": "Grenada",
      "GP": "Guadeloupe",
      "GU": "Guam",
      "GT": "Guatemala",
      "GG": "Guernsey",
      "GN": "Guinea",
      "GW": "Guinea-Bissau",
      "GY": "Guyana",
      "HT": "Haiti",
      "HM": "Heard Island and McDonald Islands",
      "VA": "Holy See",
      "HN": "Honduras",
      "HK": "Hong Kong",
      "HU": "Hungary",
      "IS": "Iceland",
      "IN": "India",
      "ID": "Indonesia",
      "IR": "Iran (Islamic Republic of)",
      "IQ": "Iraq",
      "IE": "Ireland",
      "IM": "Isle of Man",
      "IL": "Israel",
      "IT": "Italy",
      "JM": "Jamaica",
      "JP": "Japan",
      "JE": "Jersey",
      "JO": "Jordan",
      "KZ": "Kazakhstan",
      "KE": "Kenya",
      "KI": "Kiribati",
      "KP": "Korea (Democratic People's Republic of)",
      "KR": "Korea (Republic of)",
      "KW": "Kuwait",
      "KG": "Kyrgyzstan",
      "LA": "Lao People's Democratic Republic",
      "LV": "Latvia",
      "LB": "Lebanon",
      "LS": "Lesotho",
      "LR": "Liberia",
      "LY": "Libya",
      "LI": "Liechtenstein",
      "LT": "Lithuania",
      "LU": "Luxembourg",
      "MO": "Macao",
      "MG": "Madagascar",
      "MW": "Malawi",
      "MY": "Malaysia",
      "MV": "Maldives",
      "ML": "Mali",
      "MT": "Malta",
      "MH": "Marshall Islands",
      "MQ": "Martinique",
      "MR": "Mauritania",
      "MU": "Mauritius",
      "YT": "Mayotte",
      "MX": "Mexico",
      "FM": "Micronesia (Federated States of)",
      "MD": "Moldova (Republic of)",
      "MC": "Monaco",
      "MN": "Mongolia",
      "ME": "Montenegro",
      "MS": "Montserrat",
      "MA": "Morocco",
      "MZ": "Mozambique",
      "MM": "Myanmar",
      "NA": "Namibia",
      "NR": "Nauru",
      "NP": "Nepal",
      "NL": "Netherlands",
      "NC": "New Caledonia",
      "NZ": "New Zealand",
      "NI": "Nicaragua",
      "NE": "Niger",
      "NG": "Nigeria",
      "NU": "Niue",
      "NF": "Norfolk Island",
      "MK": "North Macedonia",
      "MP": "Northern Mariana Islands",
      "NO": "Norway",
      "OM": "Oman",
      "PK": "Pakistan",
      "PW": "Palau",
      "PS": "Palestine, State of",
      "PA": "Panama",
      "PG": "Papua New Guinea",
      "PY": "Paraguay",
      "PE": "Peru",
      "PH": "Philippines",
      "PN": "Pitcairn",
      "PL": "Poland",
      "PT": "Portugal",
      "PR": "Puerto Rico",
      "QA": "Qatar",
      "RE": "Réunion",
      "RO": "Romania",
      "RU": "Russian Federation",
      "RW": "Rwanda",
      "BL": "Saint Barthélemy",
      "SH": "Saint Helena, Ascension and Tristan da Cunha",
      "KN": "Saint Kitts and Nevis",
      "LC": "Saint Lucia",
      "MF": "Saint Martin (French part)",
      "PM": "Saint Pierre and Miquelon",
      "VC": "Saint Vincent and the Grenadines",
      "WS": "Samoa",
      "SM": "San Marino",
      "ST": "Sao Tome and Principe",
      "SA": "Saudi Arabia",
      "SN": "Senegal",
      "RS": "Serbia",
      "SC": "Seychelles",
      "SL": "Sierra Leone",
      "SG": "Singapore",
      "SX": "Sint Maarten (Dutch part)",
      "SK": "Slovakia",
      "SI": "Slovenia",
      "SB": "Solomon Islands",
      "SO": "Somalia",
      "ZA": "South Africa",
      "GS": "South Georgia and the South Sandwich Islands",
      "SS": "South Sudan",
      "ES": "Spain",
      "LK": "Sri Lanka",
      "SD": "Sudan",
      "SR": "Suriname",
      "SJ": "Svalbard and Jan Mayen",
      "SE": "Sweden",
      "CH": "Switzerland",
      "SY": "Syrian Arab Republic",
      "TW": "Taiwan",
      "TJ": "Tajikistan",
      "TZ": "Tanzania, United Republic of",
      "TH": "Thailand",
      "TL": "Timor-Leste",
      "TG": "Togo",
      "TK": "Tokelau",
      "TO": "Tonga",
      "TT": "Trinidad and Tobago",
      "TN": "Tunisia",
      "TR": "Turkey",
      "TM": "Turkmenistan",
      "TC": "Turks and Caicos Islands",
      "TV": "Tuvalu",
      "UG": "Uganda",
      "UA": "Ukraine",
      "AE": "United Arab Emirates",
      "GB": "United Kingdom",
      "US": "United States",
      "UM": "United States Minor Outlying Islands",
      "UY": "Uruguay",
      "UZ": "Uzbekistan",
      "VU": "Vanuatu",
      "VE": "Venezuela",
      "VN": "Viet Nam",
      "VG": "Virgin Islands (British)",
      "VI": "Virgin Islands (U.S.)",
      "WF": "Wallis and Futuna",
      "EH": "Western Sahara",
      "YE": "Yemen",
      "ZM": "Zambia",
      "ZW": "Zimbabwe"
  };

  function updateCartCountryCode(){
    let cartTaxes =  jQuery("#cartPageTax");    
  }
  function getShippingData(countryInfo) {
      console.log(countryInfo);
      let data = {};
      // Determine multiplier (only if not excluded from discount)
      let multi = 1;
      if (jQuery("body").data("ddiscount_code_p") ) {
          multi = 1 - ( jQuery("body").data("ddiscount_code_p") / 100);
      }
      data.multiplier = multi;
      data.discountPercentage = Math.round((1 - multi) * 100);
  
      // US-specific monthly payment info
      if (countryInfo.countryCode === "US") {
          const main_product = getMainProduct();
          if (main_product) {
              const monthly_price = get_nice_price(main_product.price / 400 * multi, countryInfo.currency);
              data.monthlyPrice = monthly_price;
              data.showMonthlyPayments = true;
              data.shopPayPromise = "Starting at " + monthly_price + " / month";
          }
      }
  
      // Free shipping information
      if (countryInfo.isFreeShippingAvailable) {
          data.freeShippingAvailable = true;
          const formattedThreshold = get_nice_price(countryInfo.threshold, countryInfo.currency);
          data.freeShippingThresholdRaw = countryInfo.threshold;
          data.freeShippingThreshold = formattedThreshold;
          data.freeShippingMessage = "Free shipping over " + formattedThreshold;
      } else {
          data.freeShippingAvailable = false;
      }
  
      // Shipping details
      if (countryInfo.isShippingAvailable) {
          data.shippingAvailable = true;
          if (countryInfo.isFreeShippingAvailable) {
              const formattedThreshold = get_nice_price(countryInfo.threshold, countryInfo.currency);
              data.discountBanner = "New Year Sale:<br> <span class=\"discount-percentage\">" +
                                      data.discountPercentage +
                                      "</span>% off & free shipping over <span class=\"shipping-threshold\">" +
                                      formattedThreshold + "</span>";
              data.promoCardCopy = "New year new gear. Save <span class=\"discount-percentage\">" +
                                    data.discountPercentage +
                                    "</span>% storewide and get free shipping on orders over <span class=\"shipping-threshold\">" +
                                    formattedThreshold +
                                    "</span>. Don't miss out!";
              data.showFreeShipping = true;
          } else {
              data.discountBanner = "New Year Sale: Save <span class=\"discount-percentage\">" +
                                      data.discountPercentage +
                                      "</span>% on everything";
              data.promoCardCopy = "New year, new gear! Save <span class=\"discount-percentage\">" +
                                    data.discountPercentage +
                                    "</span>% storewide on everything. Don't miss out!";
              data.showFreeShipping = false;
          }
          // Shipping time details: if shippingDaysMax is less than 12, show a range; otherwise, show a generic message
          if (countryInfo.shippingDaysMax < 12) {
              data.shippingTimeDays = countryInfo.shippingDaysMin + "-" + countryInfo.shippingDaysMax;
              data.shippingCountry = countries[countryInfo.countryCode];
            data.shippingMessage = countryInfo.shippingDaysMin + "-" + countryInfo.shippingDaysMax + " days delivery in " + countries[countryInfo.countryCode];
          } else {
              data.shippingMessage = "Ships to " + countries[countryInfo.countryCode];
          }
          data.Country = countries[countryInfo.countryCode];
          data.deliveryTimePromise = countryInfo.shippingDaysMin + "-" + countryInfo.shippingDaysMax +
                                       " days delivery in " + countries[countryInfo.countryCode];
      } else {
          data.shippingAvailable = false;
          data.shippingMessage = "Ships worldwide";
      }
  
      // Tax inclusion flag
      data.taxIncluded = !!countryInfo.isTaxIncluded;
  
      return data;
  }
  function getShippingData2(){
    var countryShipping = getWithExpiry("countryShipping");
    if( countryShipping == null ) return false;
    countryShipping = JSON.parse(countryShipping);
    var shippingData = getShippingData( getCountryShippingInfo( countryShipping ) );    
    if( shippingData === false ) return false;
    return shippingData;
  }  
  function updateShippingDetailsHTML(elementID, countriesData) {
      var countriesData = getCountryShippingInfo(countriesData);
      if( countriesData === false ) return false;
      const shippingData = getShippingData(countriesData);
      console.log(shippingData);
      updateShippingSideCart(shippingData);
      // Update discount percentage element
      jQuery(".c_discount-percentage").html(shippingData.discountPercentage + "%");  
      // Update US-specific monthly payment section if available
      if (shippingData.showMonthlyPayments) {
          jQuery("#" + elementID + " .hMonthlyPayments .Monthly, #prodAddFix .hMonthlyPayments .Monthly").html(shippingData.monthlyPrice);
          jQuery("#" + elementID + " .hMonthlyPayments").show();
          jQuery(".shop-pay-promise").html(shippingData.shopPayPromise).show();
      }  
      // Update free shipping section if free shipping is available
      if (shippingData.freeShippingAvailable) {
          jQuery("#" + elementID + " .freeShipping").show();
          jQuery("#" + elementID + " .freeShippingThreshold").html(shippingData.freeShippingThreshold);
          jQuery(".free-shipping-promise").html(shippingData.freeShippingMessage).show();
      }  
      // Update shipping details section
      if (shippingData.shippingAvailable) {
          jQuery(".c_country_name").html("in " + shippingData.Country);
          // Update discount banner and promo card copy
          jQuery(".c_discount-banner").html(shippingData.discountBanner);
          // Update promo card threshold if available
          if (shippingData.freeShippingThreshold) {
              jQuery(".c_FreeShippingThreshold").html(shippingData.freeShippingThreshold);
          }
          jQuery(".c_promo-card-copy").html(shippingData.promoCardCopy);
  
          // Toggle free shipping visibility based on data flag
          if (shippingData.showFreeShipping) {
              jQuery(".freeShipping").show();
              jQuery(".freeShippingNot").hide();
          } else {
              jQuery(".freeShipping").hide();
              jQuery(".freeShippingNot").show();
          }  
          jQuery("#" + elementID + " .shippingTime, #prodAddFix .shippingTime.desktop").html( "<i class='i i-box_2'></i> " + shippingData.shippingMessage).show();
          jQuery("#prodAddFix .shippingTime.mobile").html("Ships to " + shippingData.Country).show();
      } else {
          jQuery("#" + elementID + " .shippingTime, #prodAddFix .shippingTime.desktop").html("<i class='i i-box_2'></i> " + shippingData.shippingMessage).show();
          jQuery("#prodAddFix .shippingTime.mobile").html("Ships to " + shippingData.Country).show();
      }  
      // Show taxes included section if applicable
      if (shippingData.taxIncluded) {
          jQuery("#" + elementID + " .taxesIncluded").show();
      } 
      jQuery("#productUSPinfo").show();
  }
  
  /*
  function updateShippingDetails(elementID, countryInfo){
    let multi = 1;
    if (jQuery("body").data("multiplier") && jQuery(".product-amount-info").hasClass("exclude_discount") == false ) {
        multi = jQuery("body").data("multiplier");
    }
    const discountPercentage = Math.round((1 - multi) * 100);
    jQuery(".c_discount-percentage").html( discountPercentage + "%");
    var i=0;
      //US SPECIFIC
      if( countryInfo.countryCode == "US"){  
        var main_product =  getMainProduct();
        if (main_product) {
          console.log(main_product);
          var monthly_price = get_nice_price( main_product.price / 400 * multi, countryInfo.currency);
          jQuery("#"+elementID+" .hMonthlyPayments .Monthly").html(monthly_price);
          jQuery("#"+elementID+" .hMonthlyPayments").show();
          jQuery(".shop-pay-promise").html(" Starting at "+monthly_price+" / month" ).show();
        }          
      }
    if( countryInfo.isFreeShippingAvailable == true){
      i++;
      jQuery("#"+elementID+" .freeShipping").show();
          var moneyFormated = get_nice_price(countryInfo.threshold, countryInfo.currency);
      jQuery("#"+elementID+" .freeShippingThreshold").html( moneyFormated);
          jQuery(".free-shipping-promise").html( " Free shipping over " +moneyFormated ).show();
    }
    console.log(countryInfo);
    if( countryInfo.isShippingAvailable == true ){
      //######################    NEW CODE FOR PROMISES   #####################
      // Calculate actual discount percentage from multiplier
      

      if (countryInfo.isFreeShippingAvailable === true) {
          const formattedThreshold = get_nice_price(countryInfo.threshold, countryInfo.currency);
          
          // Update sticky banner
          jQuery(".c_discount-banner").html(`
              New Year Sale:<br> 
              <span class="discount-percentage">${discountPercentage}</span>% off & free shipping over 
              <span class="shipping-threshold">${formattedThreshold}</span>
          `);
          jQuery(".c_FreeShippingThreshold").html(formattedThreshold);

          // Update promo card
          jQuery(".c_promo-card-copy").html(`
              New year new gear. Save 
              <span class="discount-percentage">${discountPercentage}</span>% storewide 
              and get free shipping on orders over 
              <span class="shipping-threshold">${formattedThreshold}</span>. 
              Don't miss out!
          `);
          jQuery(".freeShipping").show();
          jQuery(".freeShippingNot").hide();
      } else {
          // Update content for non-free shipping countries
          jQuery(".c_discount-banner").html(`
              New Year Sale: Save 
              <span class="discount-percentage">${discountPercentage}</span>% on everything
          `);

          jQuery(".c_promo-card-copy").html(`
              New year, new gear! Save 
              <span class="discount-percentage">${discountPercentage}</span>% storewide 
              on everything. Don't miss out!
          `);
          jQuery(".freeShipping").hide();
          jQuery(".freeShippingNot").show();
      }
      //######################################################################
      i++;      
      if( countryInfo.shippingDaysMax < 12){
        jQuery("#"+elementID+" .shippingTime .days").html( countryInfo.shippingDaysMin +"-"+countryInfo.shippingDaysMax);
        jQuery("#"+elementID+" .shippingTime .country").html( countries[countryInfo.countryCode] );
      }else{        
        jQuery("#"+elementID+" .shippingTime").html("<i class='i i-box_2'></i> Ships to "+countries[countryInfo.countryCode] ).show();
      }      
      jQuery("#"+elementID+" .shippingTime").show();
      jQuery(".delivery-time-promise").html( countryInfo.shippingDaysMin +"-"+countryInfo.shippingDaysMax + " in " + countries[countryInfo.countryCode] );
  
    }else{
      jQuery("#productUSPinfo").show();
      jQuery("#"+elementID+" .shippingTime").html("<i class='i i-box_2'></i> Ships worldwide").show();
    }
    if(countryInfo.isTaxIncluded == true){
      i++;
      jQuery("#"+elementID+" .taxesIncluded").show();
    }
    if(i > 0){
      jQuery("#productUSPinfo").show();
    }
  }
  */
  function getCountryShippingInfo(countryShipping){
    var shippingInfoC = findCountryByCode(countryShipping, jQuery("html").data("location"));
    if( shippingInfoC != false) return shippingInfoC;
    return false;
  }
  function updateCountryShippingHTML(countryShipping){
    var shippingInfoC = getCountryShippingInfo(countryShipping);
    if( shippingInfoC != false){
      updateShippingDetails("productUSPinfo", shippingInfoC);
    }
  }
  var countryShipping = getWithExpiry("countryShipping");  
  if( countryShipping == null ){
  	console.log("Didn't find country info. Getting it");
    $.post({
        url: "https://cloud.soundbrenner.com/parse/classes/ShopifyCountryInfo",
        headers: {
            "Content-Type": "application/json; charset=utf-8"
        },
        data: JSON.stringify({
            "_ApplicationId": "xHSRqzrP5OHaCtNqBvj6oe44JtSfDxc2tJkBHMzo",
            "order": "countryCode",
            "_method": "GET",
            "limit": 2000
        }),
        success: function(response) {
            console.log("Response:", response);
            //updateCountryShippingHTML(response.results);
            updateShippingDetailsHTML("productUSPinfo", response.results);
            setWithExpiry("countryShipping", JSON.stringify(response.results), 1*24*60*60*1000);
        },
        error: function(error) {
            console.error("Error:", error);
        }
    });
  }else{
    countryShipping = JSON.parse(countryShipping);
    //updateCountryShippingHTML(countryShipping);    
    updateShippingDetailsHTML("productUSPinfo", countryShipping);
  }
  /*###################################*/


function updateSideCart(cart) {
    console.log(cart);
    updateShippingSideCart(false, cart.total_price );
    const cartPopProducts = document.querySelector('.cartPopProducts');
    const cartPopFooter = document.getElementById('cartPopFooter');
    const cartPopDiscountAppTxt = document.getElementById('cartPopDiscountAppTxt');

    // Clear the current cart items
    cartPopProducts.innerHTML = '';
    cartQty = 0;
    if (cart.items.length === 0) {
        // You can show an empty cart message here if needed
        cartPopProducts.innerHTML = '<p id="sideCartEmpty">You have no products in the cart.</p>';
    } else {
        cart.items.forEach(item => {
            var subtitle = "";
            var varTitleClass = "";
            if(item.variant_title != "" && item.variant_title != null && item.variant_title != "Default Title"){
              subtitle  = "<div class='cartPopProdSubitle'>"+item.variant_title+"</div>";
              varTitleClass ="cartPopProductVar";
            }

            const productHTML = `
                <div class="cartPopProduct ${varTitleClass} ${item.original_line_price == item.line_price ? `priceNoPromo` : ''}" data-cart_item_id="${item.id}" data-prod_id="${item.product_id}" data-prod_vid="${item.variant_id}">
                    <div class="cartPopProdImg">
                        <a href="${item.url}">
                            <img src="${item.image}" width="100" height="100" alt="${item.product_title}" />
                        </a>
                    </div>
                    <div class="cartPopProdTxt">
                        <div class="cartPopProdTitle">
                            <a href="${item.url}">${item.product_title}</a>${subtitle}
                        </div>
                        <div class="cartPopProdPrice">
                            ${item.original_line_price > item.line_price ? `<span class='priceOld'>${get_nice_price( Math.ceil(item.original_line_price /100), cart.currency)}</span>` : ''}
                            <span class="${item.original_line_price > item.line_price ? `priceNew` : `priceNoPromo`}">${get_nice_price(Math.ceil(item.line_price/100), cart.currency)}</span>
                        </div>
                        <div class="removeCartLine" data-id="${item.id}">
                            <i class="i i-trash_bin"></i>
                        </div>
                    </div>
                    <div class="cartPopProdQty">
                        <i class="i i-minus qMinus ${item.quantity === 1 ? 'inactive' : ''}"></i>
                        <span class="qVal" data-qty="${item.quantity}">${item.quantity}</span>
                        <i class="i i-plus qPlus"></i>
                    </div>
                </div>
            `;
            cartPopProducts.innerHTML += productHTML;
            cartQty += item.quantity;
        });
    }
    console.log(cartQty);
    updateCartItemsNR(cartQty);

    // Update the cart subtotal, taxes, savings, and total
    jQuery('#cartPageSubTotal').html(get_nice_price(Math.ceil(cart.original_total_price/100), cart.currency));
    if (cart.taxes_included) {
        //jQuery('#cartPageTax').html('Included');
    } else {
        //jQuery('#cartPageTax').html('Calculated at checkout');
    }

    if (cart.total_discount > 0) {
        jQuery('.shopSaving').show();
        jQuery('#cartSaving').html( get_nice_price(Math.ceil(cart.total_discount/100), cart.currency) );
    } else {
        jQuery('.shopSaving').hide();
    }

    jQuery('#cartPopTotal').html( get_nice_price(Math.ceil(cart.total_price/100), cart.currency) );

    // If there's a discount applied, show the discount message
    if (cart.discount_code) {
        //cartPopDiscountAppTxt.style.display = 'block';
        //cartPopDiscountAppTxt.innerText = `Your discount ${cart.discount_code} has been applied!`;
    } else {
        //cartPopDiscountAppTxt.style.display = 'none';
    }
}

// Helper function to format the money value
function formatMoney(cents) {
    currency_symbol = jQuery("body").data("currency_symbol");
    return (cents / 100).toFixed(2) + currency_symbol; // Adjust the currency format as needed
}
function setCookie(cname,cvalue,exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    if( exdays === 0 ){
        var expires = "";
    }else{
        var expires = "expires=" + d.toGMTString()+";";
    }
    document.cookie = cname + "=" + cvalue + ";" + expires + "path=/;";
}
function getCookie(cname) {
    //cname = cname.replace(/-/g, ' ');
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
function getWithExpiry(key) {
    const itemStr = localStorage.getItem(key)
    // if the item doesn't exist, return null
    if (!itemStr) {
        return null
    }
    const item = JSON.parse(itemStr)
    const now = new Date()
    // compare the expiry time of the item with the current time
    if (now.getTime() > item.expiry) {
        // If the item is expired, delete the item from storage
        // and return null
        localStorage.removeItem(key)
        return null
    }
    return item.value
}
function setWithExpiry(key, value, ttl) {
    const now = new Date()
    
    // `item` is an object which contains the original value
    // as well as the time when it's supposed to expire
      const item = {
          value: value,
          expiry: now.getTime() + ttl
      }
      localStorage.setItem(key, JSON.stringify(item))
}
function updateCartQuantity(productId, qty) {
    let data = {
        "id" : ""+productId+"",
        "quantity" : qty
    }
    console.log(data)
    var modal = new tingle.modal({
        footer: false,
        stickyFooter: false,
        closeMethods: ['overlay', 'button', 'escape'],
        closeLabel: "Close",
        cssClass: ['tingle_modal_atc', 'custom-class-2'],
        onOpen: function() {},
        onClose: function() { modal.destroy(); },
        beforeClose: function() {
            return true; // close the modal
            return false; // nothing happens
        }
    }); 
    modal.setContent('<div id="loadingCIcon"></div><div id="loadingCTxt">Updating your cart, please wait</div>');
    modal.open();  
    fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(cart => {
        updateSideCart(cart);
        modal.close();
        jQuery("#cartPop").addClass("active");
    })
    .catch(error => {
        console.error('Error updating cart:', error);
    });
}
function aCountdown(timetocount){
    var eDays = document.getElementById("afDays");
    var eHours = document.getElementById("afHours");
    var afMin = document.getElementById("afMin");
    var afSec = document.getElementById("afSec");
    var countDownDate = new Date(timetocount).getTime();
    var x = setInterval(function() {
        var now = new Date().getTime();
        var distance = countDownDate - now;
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);
        eDays.innerHTML = days;
        eHours.innerHTML = hours;
        afMin.innerHTML = minutes;
        afSec.innerHTML = seconds;
        if (distance < 0) {
            clearInterval(x);
            eDays.innerHTML = 0;
            eHours.innerHTML = 0;
            afMin.innerHTML = 0;
            afSec.innerHTML = 0;
        }
    }, 1000);
}
function discountCD(dStr){
    var d = new Date(dStr);
    var localTime = d.getTime();
    var offset = 8;//hours
    var localOffsetHours = d.getTimezoneOffset() / 60;
    var tdif = localOffsetHours + offset;
    //console.log("localOffsetHours:"+localOffsetHours);
    var localOffset = d.getTimezoneOffset() * 60000;
    //console.log("localOffset"+localOffset);
    var utc = localTime + localOffset;
    var time_to_promo_end = localTime - (60 * 60 * 1000 * tdif);
    aCountdown(time_to_promo_end);
}
//##################################   VIMEO   ################################################
/*! @vimeo/player v2.23.0 | (c) 2024 Vimeo | MIT License | https://github.com/vimeo/player.js */
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):((e="undefined"!=typeof globalThis?globalThis:e||self).Vimeo=e.Vimeo||{},e.Vimeo.Player=t())}(this,function(){"use strict";function r(t,e){var n,r=Object.keys(t);return Object.getOwnPropertySymbols&&(n=Object.getOwnPropertySymbols(t),e&&(n=n.filter(function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable})),r.push.apply(r,n)),r}function u(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?r(Object(n),!0).forEach(function(e){s(t,e,n[e])}):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):r(Object(n)).forEach(function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))})}return t}function j(){j=function(){return a};var a={},e=Object.prototype,s=e.hasOwnProperty,f=Object.defineProperty||function(e,t,n){e[t]=n.value},t="function"==typeof Symbol?Symbol:{},o=t.iterator||"@@iterator",n=t.asyncIterator||"@@asyncIterator",r=t.toStringTag||"@@toStringTag";function i(e,t,n){return Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}),e[t]}try{i({},"")}catch(e){i=function(e,t,n){return e[t]=n}}function u(e,t,n,r){var i,a,u,c,o=t&&t.prototype instanceof p?t:p,l=Object.create(o.prototype),s=new x(r||[]);return f(l,"_invoke",{value:(i=e,a=n,u=s,c="suspendedStart",function(e,t){if("executing"===c)throw new Error("Generator is already running");if("completed"===c){if("throw"===e)throw t;return T()}for(u.method=e,u.arg=t;;){var n=u.delegate;if(n){var r=function e(t,n){var r=n.method,o=t.iterator[r];if(void 0===o)return n.delegate=null,"throw"===r&&t.iterator.return&&(n.method="return",n.arg=void 0,e(t,n),"throw"===n.method)||"return"!==r&&(n.method="throw",n.arg=new TypeError("The iterator does not provide a '"+r+"' method")),h;var i=d(o,t.iterator,n.arg);if("throw"===i.type)return n.method="throw",n.arg=i.arg,n.delegate=null,h;var a=i.arg;return a?a.done?(n[t.resultName]=a.value,n.next=t.nextLoc,"return"!==n.method&&(n.method="next",n.arg=void 0),n.delegate=null,h):a:(n.method="throw",n.arg=new TypeError("iterator result is not an object"),n.delegate=null,h)}(n,u);if(r){if(r===h)continue;return r}}if("next"===u.method)u.sent=u._sent=u.arg;else if("throw"===u.method){if("suspendedStart"===c)throw c="completed",u.arg;u.dispatchException(u.arg)}else"return"===u.method&&u.abrupt("return",u.arg);c="executing";var o=d(i,a,u);if("normal"===o.type){if(c=u.done?"completed":"suspendedYield",o.arg===h)continue;return{value:o.arg,done:u.done}}"throw"===o.type&&(c="completed",u.method="throw",u.arg=o.arg)}})}),l}function d(e,t,n){try{return{type:"normal",arg:e.call(t,n)}}catch(e){return{type:"throw",arg:e}}}a.wrap=u;var h={};function p(){}function c(){}function l(){}var v={};i(v,o,function(){return this});var y=Object.getPrototypeOf,m=y&&y(y(P([])));m&&m!==e&&s.call(m,o)&&(v=m);var g=l.prototype=p.prototype=Object.create(v);function w(e){["next","throw","return"].forEach(function(t){i(e,t,function(e){return this._invoke(t,e)})})}function b(c,l){var t;f(this,"_invoke",{value:function(n,r){function e(){return new l(function(e,t){!function t(e,n,r,o){var i=d(c[e],c,n);if("throw"!==i.type){var a=i.arg,u=a.value;return u&&"object"==typeof u&&s.call(u,"__await")?l.resolve(u.__await).then(function(e){t("next",e,r,o)},function(e){t("throw",e,r,o)}):l.resolve(u).then(function(e){a.value=e,r(a)},function(e){return t("throw",e,r,o)})}o(i.arg)}(n,r,e,t)})}return t=t?t.then(e,e):e()}})}function k(e){var t={tryLoc:e[0]};1 in e&&(t.catchLoc=e[1]),2 in e&&(t.finallyLoc=e[2],t.afterLoc=e[3]),this.tryEntries.push(t)}function E(e){var t=e.completion||{};t.type="normal",delete t.arg,e.completion=t}function x(e){this.tryEntries=[{tryLoc:"root"}],e.forEach(k,this),this.reset(!0)}function P(t){if(t){var e=t[o];if(e)return e.call(t);if("function"==typeof t.next)return t;if(!isNaN(t.length)){var n=-1,r=function e(){for(;++n<t.length;)if(s.call(t,n))return e.value=t[n],e.done=!1,e;return e.value=void 0,e.done=!0,e};return r.next=r}}return{next:T}}function T(){return{value:void 0,done:!0}}return f(g,"constructor",{value:c.prototype=l,configurable:!0}),f(l,"constructor",{value:c,configurable:!0}),c.displayName=i(l,r,"GeneratorFunction"),a.isGeneratorFunction=function(e){var t="function"==typeof e&&e.constructor;return!!t&&(t===c||"GeneratorFunction"===(t.displayName||t.name))},a.mark=function(e){return Object.setPrototypeOf?Object.setPrototypeOf(e,l):(e.__proto__=l,i(e,r,"GeneratorFunction")),e.prototype=Object.create(g),e},a.awrap=function(e){return{__await:e}},w(b.prototype),i(b.prototype,n,function(){return this}),a.AsyncIterator=b,a.async=function(e,t,n,r,o){void 0===o&&(o=Promise);var i=new b(u(e,t,n,r),o);return a.isGeneratorFunction(t)?i:i.next().then(function(e){return e.done?e.value:i.next()})},w(g),i(g,r,"Generator"),i(g,o,function(){return this}),i(g,"toString",function(){return"[object Generator]"}),a.keys=function(e){var n=Object(e),r=[];for(var t in n)r.push(t);return r.reverse(),function e(){for(;r.length;){var t=r.pop();if(t in n)return e.value=t,e.done=!1,e}return e.done=!0,e}},a.values=P,x.prototype={constructor:x,reset:function(e){if(this.prev=0,this.next=0,this.sent=this._sent=void 0,this.done=!1,this.delegate=null,this.method="next",this.arg=void 0,this.tryEntries.forEach(E),!e)for(var t in this)"t"===t.charAt(0)&&s.call(this,t)&&!isNaN(+t.slice(1))&&(this[t]=void 0)},stop:function(){this.done=!0;var e=this.tryEntries[0].completion;if("throw"===e.type)throw e.arg;return this.rval},dispatchException:function(n){if(this.done)throw n;var r=this;function e(e,t){return i.type="throw",i.arg=n,r.next=e,t&&(r.method="next",r.arg=void 0),!!t}for(var t=this.tryEntries.length-1;0<=t;--t){var o=this.tryEntries[t],i=o.completion;if("root"===o.tryLoc)return e("end");if(o.tryLoc<=this.prev){var a=s.call(o,"catchLoc"),u=s.call(o,"finallyLoc");if(a&&u){if(this.prev<o.catchLoc)return e(o.catchLoc,!0);if(this.prev<o.finallyLoc)return e(o.finallyLoc)}else if(a){if(this.prev<o.catchLoc)return e(o.catchLoc,!0)}else{if(!u)throw new Error("try statement without catch or finally");if(this.prev<o.finallyLoc)return e(o.finallyLoc)}}}},abrupt:function(e,t){for(var n=this.tryEntries.length-1;0<=n;--n){var r=this.tryEntries[n];if(r.tryLoc<=this.prev&&s.call(r,"finallyLoc")&&this.prev<r.finallyLoc){var o=r;break}}o&&("break"===e||"continue"===e)&&o.tryLoc<=t&&t<=o.finallyLoc&&(o=null);var i=o?o.completion:{};return i.type=e,i.arg=t,o?(this.method="next",this.next=o.finallyLoc,h):this.complete(i)},complete:function(e,t){if("throw"===e.type)throw e.arg;return"break"===e.type||"continue"===e.type?this.next=e.arg:"return"===e.type?(this.rval=this.arg=e.arg,this.method="return",this.next="end"):"normal"===e.type&&t&&(this.next=t),h},finish:function(e){for(var t=this.tryEntries.length-1;0<=t;--t){var n=this.tryEntries[t];if(n.finallyLoc===e)return this.complete(n.completion,n.afterLoc),E(n),h}},catch:function(e){for(var t=this.tryEntries.length-1;0<=t;--t){var n=this.tryEntries[t];if(n.tryLoc===e){var r,o=n.completion;return"throw"===o.type&&(r=o.arg,E(n)),r}}throw new Error("illegal catch attempt")},delegateYield:function(e,t,n){return this.delegate={iterator:P(e),resultName:t,nextLoc:n},"next"===this.method&&(this.arg=void 0),h}},a}function c(e,t,n,r,o,i,a){try{var u=e[i](a),c=u.value}catch(e){return void n(e)}u.done?t(c):Promise.resolve(c).then(r,o)}function h(u){return function(){var e=this,a=arguments;return new Promise(function(t,n){var r=u.apply(e,a);function o(e){c(r,t,n,o,i,"next",e)}function i(e){c(r,t,n,o,i,"throw",e)}o(void 0)})}}function l(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,y(r.key),r)}}function e(e,t,n){return t&&o(e.prototype,t),n&&o(e,n),Object.defineProperty(e,"prototype",{writable:!1}),e}function s(e,t,n){return(t=y(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function i(e){return(i=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function f(e,t){return(f=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(e,t){return e.__proto__=t,e})(e,t)}function a(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(e){return!1}}function d(e,t,n){return(d=a()?Reflect.construct.bind():function(e,t,n){var r=[null];r.push.apply(r,t);var o=new(Function.bind.apply(e,r));return n&&f(o,n.prototype),o}).apply(null,arguments)}function t(e){var r="function"==typeof Map?new Map:void 0;return(t=function(e){if(null===e||(t=e,-1===Function.toString.call(t).indexOf("[native code]")))return e;var t;if("function"!=typeof e)throw new TypeError("Super expression must either be null or a function");if(void 0!==r){if(r.has(e))return r.get(e);r.set(e,n)}function n(){return d(e,arguments,i(this).constructor)}return n.prototype=Object.create(e.prototype,{constructor:{value:n,enumerable:!1,writable:!0,configurable:!0}}),f(n,e)})(e)}function p(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function v(n){var r=a();return function(){var e,t=i(n);return function(e,t){if(t&&("object"==typeof t||"function"==typeof t))return t;if(void 0!==t)throw new TypeError("Derived constructors may only return object or undefined");return p(e)}(this,r?(e=i(this).constructor,Reflect.construct(t,arguments,e)):t.apply(this,arguments))}}function y(e){var t=function(e,t){if("object"!=typeof e||null===e)return e;var n=e[Symbol.toPrimitive];if(void 0===n)return("string"===t?String:Number)(e);var r=n.call(e,t||"default");if("object"!=typeof r)return r;throw new TypeError("@@toPrimitive must return a primitive value.")}(e,"string");return"symbol"==typeof t?t:String(t)}var n="undefined"!=typeof global&&"[object global]"==={}.toString.call(global);function m(e,t){return 0===e.indexOf(t.toLowerCase())?e:"".concat(t.toLowerCase()).concat(e.substr(0,1).toUpperCase()).concat(e.substr(1))}function g(e){return/^(https?:)?\/\/((((player|www)\.)?vimeo\.com)|((player\.)?[a-zA-Z0-9-]+\.videoji\.hk))(?=$|\/)/.test(e)}function w(e){return/^https:\/\/player\.((vimeo\.com)|([a-zA-Z0-9-]+\.videoji\.hk))\/video\/\d+/.test(e)}function b(e){var t,n=0<arguments.length&&void 0!==e?e:{},r=n.id,o=n.url,i=r||o;if(!i)throw new Error("An id or url must be passed, either in an options object or as a data-vimeo-id or data-vimeo-url attribute.");if(t=i,!isNaN(parseFloat(t))&&isFinite(t)&&Math.floor(t)==t)return"https://vimeo.com/".concat(i);if(g(i))return i.replace("http:","https:");if(r)throw new TypeError("“".concat(r,"” is not a valid video id."));throw new TypeError("“".concat(i,"” is not a vimeo.com url."))}function k(t,e,n,r,o){var i=3<arguments.length&&void 0!==r?r:"addEventListener",a=4<arguments.length&&void 0!==o?o:"removeEventListener",u="string"==typeof e?[e]:e;return u.forEach(function(e){t[i](e,n)}),{cancel:function(){return u.forEach(function(e){return t[a](e,n)})}}}var E=void 0!==Array.prototype.indexOf,x="undefined"!=typeof window&&void 0!==window.postMessage;if(!(n||E&&x))throw new Error("Sorry, the Vimeo Player API is not available in this browser.");var P,T,_,O,M="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};function S(){if(void 0===this)throw new TypeError("Constructor WeakMap requires 'new'");if(O(this,"_id","_WeakMap_"+N()+"."+N()),0<arguments.length)throw new TypeError("WeakMap iterable is not supported")}function C(e,t){if(!F(e)||!T.call(e,"_id"))throw new TypeError(t+" method called on incompatible receiver "+typeof e)}function N(){return Math.random().toString().substring(2)}function F(e){return Object(e)===e}(P="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:"undefined"!=typeof window?window:M).WeakMap||(T=Object.prototype.hasOwnProperty,_=Object.defineProperty&&function(){try{return 1===Object.defineProperty({},"x",{value:1}).x}catch(e){}}(),O=function(e,t,n){_?Object.defineProperty(e,t,{configurable:!0,writable:!0,value:n}):e[t]=n},P.WeakMap=(O(S.prototype,"delete",function(e){if(C(this,"delete"),!F(e))return!1;var t=e[this._id];return!(!t||t[0]!==e)&&(delete e[this._id],!0)}),O(S.prototype,"get",function(e){if(C(this,"get"),F(e)){var t=e[this._id];return t&&t[0]===e?t[1]:void 0}}),O(S.prototype,"has",function(e){if(C(this,"has"),!F(e))return!1;var t=e[this._id];return!(!t||t[0]!==e)}),O(S.prototype,"set",function(e,t){if(C(this,"set"),!F(e))throw new TypeError("Invalid value used as weak map key");var n=e[this._id];return n&&n[0]===e?n[1]=t:O(e,this._id,[e,t]),this}),O(S,"_polyfill",!0),S));var L,A=(function(e){var t,n,r;r=function(){var t,n,r,o,i,a,e=Object.prototype.toString,u="undefined"!=typeof setImmediate?function(e){return setImmediate(e)}:setTimeout;try{Object.defineProperty({},"x",{}),t=function(e,t,n,r){return Object.defineProperty(e,t,{value:n,writable:!0,configurable:!1!==r})}}catch(e){t=function(e,t,n){return e[t]=n,e}}function c(e,t){this.fn=e,this.self=t,this.next=void 0}function l(e,t){r.add(e,t),n=n||u(r.drain)}function s(e){var t,n=typeof e;return null==e||"object"!=n&&"function"!=n||(t=e.then),"function"==typeof t&&t}function f(){for(var e=0;e<this.chain.length;e++)!function(e,t,n){var r,o;try{!1===t?n.reject(e.msg):(r=!0===t?e.msg:t.call(void 0,e.msg))===n.promise?n.reject(TypeError("Promise-chain cycle")):(o=s(r))?o.call(r,n.resolve,n.reject):n.resolve(r)}catch(e){n.reject(e)}}(this,1===this.state?this.chain[e].success:this.chain[e].failure,this.chain[e]);this.chain.length=0}function d(e){var n,r=this;if(!r.triggered){r.triggered=!0,r.def&&(r=r.def);try{(n=s(e))?l(function(){var t=new v(r);try{n.call(e,function(){d.apply(t,arguments)},function(){h.apply(t,arguments)})}catch(e){h.call(t,e)}}):(r.msg=e,r.state=1,0<r.chain.length&&l(f,r))}catch(e){h.call(new v(r),e)}}}function h(e){var t=this;t.triggered||(t.triggered=!0,t.def&&(t=t.def),t.msg=e,t.state=2,0<t.chain.length&&l(f,t))}function p(e,n,r,o){for(var t=0;t<n.length;t++)!function(t){e.resolve(n[t]).then(function(e){r(t,e)},o)}(t)}function v(e){this.def=e,this.triggered=!1}function y(e){this.promise=e,this.state=0,this.triggered=!1,this.chain=[],this.msg=void 0}function m(e){if("function"!=typeof e)throw TypeError("Not a function");if(0!==this.__NPO__)throw TypeError("Not a promise");this.__NPO__=1;var r=new y(this);this.then=function(e,t){var n={success:"function"!=typeof e||e,failure:"function"==typeof t&&t};return n.promise=new this.constructor(function(e,t){if("function"!=typeof e||"function"!=typeof t)throw TypeError("Not a function");n.resolve=e,n.reject=t}),r.chain.push(n),0!==r.state&&l(f,r),n.promise},this.catch=function(e){return this.then(void 0,e)};try{e.call(void 0,function(e){d.call(r,e)},function(e){h.call(r,e)})}catch(e){h.call(r,e)}}var g=t({},"constructor",m,!(r={add:function(e,t){a=new c(e,t),i?i.next=a:o=a,i=a,a=void 0},drain:function(){var e=o;for(o=i=n=void 0;e;)e.fn.call(e.self),e=e.next}}));return t(m.prototype=g,"__NPO__",0,!1),t(m,"resolve",function(n){return n&&"object"==typeof n&&1===n.__NPO__?n:new this(function(e,t){if("function"!=typeof e||"function"!=typeof t)throw TypeError("Not a function");e(n)})}),t(m,"reject",function(n){return new this(function(e,t){if("function"!=typeof e||"function"!=typeof t)throw TypeError("Not a function");t(n)})}),t(m,"all",function(t){var a=this;return"[object Array]"!=e.call(t)?a.reject(TypeError("Not an array")):0===t.length?a.resolve([]):new a(function(n,e){if("function"!=typeof n||"function"!=typeof e)throw TypeError("Not a function");var r=t.length,o=Array(r),i=0;p(a,t,function(e,t){o[e]=t,++i===r&&n(o)},e)})}),t(m,"race",function(t){var r=this;return"[object Array]"!=e.call(t)?r.reject(TypeError("Not an array")):new r(function(n,e){if("function"!=typeof n||"function"!=typeof e)throw TypeError("Not a function");p(r,t,function(e,t){n(t)},e)})}),m},(n=M)[t="Promise"]=n[t]||r(),e.exports&&(e.exports=n[t])}(L={exports:{}}),L.exports),R=new WeakMap;function q(e,t,n){var r=R.get(e.element)||{};t in r||(r[t]=[]),r[t].push(n),R.set(e.element,r)}function I(e,t){return(R.get(e.element)||{})[t]||[]}function V(e,t,n){var r=R.get(e.element)||{};if(!r[t])return!0;if(!n)return r[t]=[],R.set(e.element,r),!0;var o=r[t].indexOf(n);return-1!==o&&r[t].splice(o,1),R.set(e.element,r),r[t]&&0===r[t].length}function D(e){if("string"==typeof e)try{e=JSON.parse(e)}catch(e){return console.warn(e),{}}return e}function W(e,t,n){var r,o;e.element.contentWindow&&e.element.contentWindow.postMessage&&(r={method:t},void 0!==n&&(r.value=n),8<=(o=parseFloat(navigator.userAgent.toLowerCase().replace(/^.*msie (\d+).*$/,"$1")))&&o<10&&(r=JSON.stringify(r)),e.element.contentWindow.postMessage(r,e.origin))}function z(n,r){var t,e,o=[];(r=D(r)).event?("error"===r.event&&I(n,r.data.method).forEach(function(e){var t=new Error(r.data.message);t.name=r.data.name,e.reject(t),V(n,r.data.method,e)}),o=I(n,"event:".concat(r.event)),t=r.data):!r.method||(e=function(e,t){var n=I(e,t);if(n.length<1)return!1;var r=n.shift();return V(e,t,r),r}(n,r.method))&&(o.push(e),t=r.value),o.forEach(function(e){try{if("function"==typeof e)return void e.call(n,t);e.resolve(t)}catch(e){}})}var U=["airplay","audio_tracks","autopause","autoplay","background","byline","cc","chapter_id","chapters","chromecast","color","colors","controls","dnt","end_time","fullscreen","height","id","interactive_params","keyboard","loop","maxheight","maxwidth","muted","play_button_position","playsinline","portrait","progress_bar","quality_selector","responsive","speed","start_time","texttrack","title","transcript","transparent","url","vimeo_logo","volume","watch_full_video","width"];function G(r,e){var t=1<arguments.length&&void 0!==e?e:{};return U.reduce(function(e,t){var n=r.getAttribute("data-vimeo-".concat(t));return!n&&""!==n||(e[t]=""===n?1:n),e},t)}function B(e,t){var n=e.html;if(!t)throw new TypeError("An element must be provided");if(null!==t.getAttribute("data-vimeo-initialized"))return t.querySelector("iframe");var r=document.createElement("div");return r.innerHTML=n,t.appendChild(r.firstChild),t.setAttribute("data-vimeo-initialized","true"),t.querySelector("iframe")}function H(c,e,t){var l=1<arguments.length&&void 0!==e?e:{},s=2<arguments.length?t:void 0;return new Promise(function(t,n){if(!g(c))throw new TypeError("“".concat(c,"” is not a vimeo.com url."));var e,r,o=(e=(c||"").match(/^(?:https?:)?(?:\/\/)?([^/?]+)/),(r=(e&&e[1]||"").replace("player.","")).endsWith(".videoji.hk")?r:"vimeo.com"),i="https://".concat(o,"/api/oembed.json?url=").concat(encodeURIComponent(c));for(var a in l)l.hasOwnProperty(a)&&(i+="&".concat(a,"=").concat(encodeURIComponent(l[a])));var u=new("XDomainRequest"in window?XDomainRequest:XMLHttpRequest);u.open("GET",i,!0),u.onload=function(){if(404!==u.status)if(403!==u.status)try{var e=JSON.parse(u.responseText);if(403===e.domain_status_code)return B(e,s),void n(new Error("“".concat(c,"” is not embeddable.")));t(e)}catch(e){n(e)}else n(new Error("“".concat(c,"” is not embeddable.")));else n(new Error("“".concat(c,"” was not found.")))},u.onerror=function(){var e=u.status?" (".concat(u.status,")"):"";n(new Error("There was an error fetching the embed code from Vimeo".concat(e,".")))},u.send()})}var Y,Q,J,X={role:"viewer",autoPlayMuted:!0,allowedDrift:.3,maxAllowedDrift:1,minCheckInterval:.1,maxRateAdjustment:.2,maxTimeToCatchUp:1},$=function(){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),Object.defineProperty(e,"prototype",{writable:!1}),t&&f(e,t)}(a,t(EventTarget));var r,n,o,i=v(a);function a(e,t){var o,n=2<arguments.length&&void 0!==arguments[2]?arguments[2]:{},r=3<arguments.length?arguments[3]:void 0;return l(this,a),s(p(o=i.call(this)),"logger",void 0),s(p(o),"speedAdjustment",0),s(p(o),"adjustSpeed",function(){var n=h(j().mark(function e(t,n){var r;return j().wrap(function(e){for(;;)switch(e.prev=e.next){case 0:if(o.speedAdjustment===n)return e.abrupt("return");e.next=2;break;case 2:return e.next=4,t.getPlaybackRate();case 4:return e.t0=e.sent,e.t1=o.speedAdjustment,e.t2=e.t0-e.t1,e.t3=n,r=e.t2+e.t3,o.log("New playbackRate:  ".concat(r)),e.next=12,t.setPlaybackRate(r);case 12:o.speedAdjustment=n;case 13:case"end":return e.stop()}},e)}));return function(e,t){return n.apply(this,arguments)}}()),o.logger=r,o.init(t,e,u(u({},X),n)),o}return e(a,[{key:"disconnect",value:function(){this.dispatchEvent(new Event("disconnect"))}},{key:"init",value:(o=h(j().mark(function e(t,n,r){var o,i,a,u=this;return j().wrap(function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,this.waitForTOReadyState(t,"open");case 2:if("viewer"===r.role)return e.next=5,this.updatePlayer(t,n,r);e.next=10;break;case 5:o=k(t,"change",function(){return u.updatePlayer(t,n,r)}),i=this.maintainPlaybackPosition(t,n,r),this.addEventListener("disconnect",function(){i.cancel(),o.cancel()}),e.next=14;break;case 10:return e.next=12,this.updateTimingObject(t,n);case 12:a=k(n,["seeked","play","pause","ratechange"],function(){return u.updateTimingObject(t,n)},"on","off"),this.addEventListener("disconnect",function(){return a.cancel()});case 14:case"end":return e.stop()}},e,this)})),function(e,t,n){return o.apply(this,arguments)})},{key:"updateTimingObject",value:(n=h(j().mark(function e(t,n){return j().wrap(function(e){for(;;)switch(e.prev=e.next){case 0:return e.t0=t,e.next=3,n.getCurrentTime();case 3:return e.t1=e.sent,e.next=6,n.getPaused();case 6:if(!e.sent){e.next=10;break}e.t2=0,e.next=13;break;case 10:return e.next=12,n.getPlaybackRate();case 12:e.t2=e.sent;case 13:e.t3=e.t2,e.t4={position:e.t1,velocity:e.t3},e.t0.update.call(e.t0,e.t4);case 16:case"end":return e.stop()}},e)})),function(e,t){return n.apply(this,arguments)})},{key:"updatePlayer",value:(r=h(j().mark(function e(t,n,r){var o,i,a;return j().wrap(function(e){for(;;)switch(e.prev=e.next){case 0:if(o=t.query(),i=o.position,a=o.velocity,"number"==typeof i&&n.setCurrentTime(i),"number"!=typeof a){e.next=25;break}if(0===a)return e.next=6,n.getPaused();e.next=11;break;case 6:if(e.t0=e.sent,!1!==e.t0){e.next=9;break}n.pause();case 9:e.next=25;break;case 11:if(0<a)return e.next=14,n.getPaused();e.next=25;break;case 14:if(e.t1=e.sent,!0===e.t1)return e.next=18,n.play().catch(function(){var t=h(j().mark(function e(t){return j().wrap(function(e){for(;;)switch(e.prev=e.next){case 0:if("NotAllowedError"===t.name&&r.autoPlayMuted)return e.next=3,n.setMuted(!0);e.next=5;break;case 3:return e.next=5,n.play().catch(function(e){return console.error("Couldn't play the video from TimingSrcConnector. Error:",e)});case 5:case"end":return e.stop()}},e)}));return function(e){return t.apply(this,arguments)}}());e.next=19;break;case 18:this.updatePlayer(t,n,r);case 19:return e.next=21,n.getPlaybackRate();case 21:if(e.t2=e.sent,e.t3=a,e.t2===e.t3){e.next=25;break}n.setPlaybackRate(a);case 25:case"end":return e.stop()}},e,this)})),function(e,t,n){return r.apply(this,arguments)})},{key:"maintainPlaybackPosition",value:function(a,u,e){var c=this,l=e.allowedDrift,s=e.maxAllowedDrift,t=e.minCheckInterval,f=e.maxRateAdjustment,d=e.maxTimeToCatchUp,n=1e3*Math.min(d,Math.max(t,s)),r=function(){var e=h(j().mark(function e(){var t,n,r,o,i;return j().wrap(function(e){for(;;)switch(e.prev=e.next){case 0:if(e.t0=0===a.query().velocity,e.t0){e.next=6;break}return e.next=4,u.getPaused();case 4:e.t1=e.sent,e.t0=!0===e.t1;case 6:if(e.t0)return e.abrupt("return");e.next=8;break;case 8:return e.t2=a.query().position,e.next=11,u.getCurrentTime();case 11:if(e.t3=e.sent,t=e.t2-e.t3,n=Math.abs(t),c.log("Drift: ".concat(t)),s<n)return e.next=18,c.adjustSpeed(u,0);e.next=22;break;case 18:u.setCurrentTime(a.query().position),c.log("Resync by currentTime"),e.next=29;break;case 22:if(l<n)return i=(r=n/d)<(o=f)?(o-r)/2:o,e.next=28,c.adjustSpeed(u,i*Math.sign(t));e.next=29;break;case 28:c.log("Resync by playbackRate");case 29:case"end":return e.stop()}},e)}));return function(){return e.apply(this,arguments)}}(),o=setInterval(function(){return r()},n);return{cancel:function(){return clearInterval(o)}}}},{key:"log",value:function(e){var t;null!==(t=this.logger)&&void 0!==t&&t.call(this,"TimingSrcConnector: ".concat(e))}},{key:"waitForTOReadyState",value:function(n,r){return new Promise(function(t){!function e(){n.readyState===r?t():n.addEventListener("readystatechange",e,{once:!0})}()})}}]),a}(),Z=new WeakMap,K=new WeakMap,ee={},Player=function(){function Player(u){var e,t,c=this,n=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{};if(l(this,Player),window.jQuery&&u instanceof jQuery&&(1<u.length&&window.console&&console.warn&&console.warn("A jQuery object with multiple elements was passed, using the first element."),u=u[0]),"undefined"!=typeof document&&"string"==typeof u&&(u=document.getElementById(u)),e=u,!Boolean(e&&1===e.nodeType&&"nodeName"in e&&e.ownerDocument&&e.ownerDocument.defaultView))throw new TypeError("You must pass either a valid element or a valid id.");if("IFRAME"===u.nodeName||(t=u.querySelector("iframe"))&&(u=t),"IFRAME"===u.nodeName&&!g(u.getAttribute("src")||""))throw new Error("The player element passed isn’t a Vimeo embed.");if(Z.has(u))return Z.get(u);this._window=u.ownerDocument.defaultView,this.element=u,this.origin="*";var r,o=new A(function(i,a){var e;c._onMessage=function(e){if(g(e.origin)&&c.element.contentWindow===e.source){"*"===c.origin&&(c.origin=e.origin);var t=D(e.data);if(t&&"error"===t.event&&t.data&&"ready"===t.data.method){var n=new Error(t.data.message);return n.name=t.data.name,void a(n)}var r=t&&"ready"===t.event,o=t&&"ping"===t.method;if(r||o)return c.element.setAttribute("data-ready","true"),void i();z(c,t)}},c._window.addEventListener("message",c._onMessage),"IFRAME"!==c.element.nodeName&&H(b(e=G(u,n)),e,u).then(function(e){var t,n,r,o=B(e,u);return c.element=o,c._originalElement=u,t=u,n=o,r=R.get(t),R.set(n,r),R.delete(t),Z.set(c.element,c),e}).catch(a)});return K.set(this,o),Z.set(this.element,this),"IFRAME"===this.element.nodeName&&W(this,"ping"),ee.isEnabled&&(r=function(){return ee.exit()},this.fullscreenchangeHandler=function(){(ee.isFullscreen?q:V)(c,"event:exitFullscreen",r),c.ready().then(function(){W(c,"fullscreenchange",ee.isFullscreen)})},ee.on("fullscreenchange",this.fullscreenchangeHandler)),this}var n;return e(Player,[{key:"callMethod",value:function(n,e){var r=this,o=1<arguments.length&&void 0!==e?e:{};return new A(function(e,t){return r.ready().then(function(){q(r,n,{resolve:e,reject:t}),W(r,n,o)}).catch(t)})}},{key:"get",value:function(n){var r=this;return new A(function(e,t){return n=m(n,"get"),r.ready().then(function(){q(r,n,{resolve:e,reject:t}),W(r,n)}).catch(t)})}},{key:"set",value:function(n,r){var o=this;return new A(function(e,t){if(n=m(n,"set"),null==r)throw new TypeError("There must be a value to set.");return o.ready().then(function(){q(o,n,{resolve:e,reject:t}),W(o,n,r)}).catch(t)})}},{key:"on",value:function(e,t){if(!e)throw new TypeError("You must pass an event name.");if(!t)throw new TypeError("You must pass a callback function.");if("function"!=typeof t)throw new TypeError("The callback must be a function.");0===I(this,"event:".concat(e)).length&&this.callMethod("addEventListener",e).catch(function(){}),q(this,"event:".concat(e),t)}},{key:"off",value:function(e,t){if(!e)throw new TypeError("You must pass an event name.");if(t&&"function"!=typeof t)throw new TypeError("The callback must be a function.");V(this,"event:".concat(e),t)&&this.callMethod("removeEventListener",e).catch(function(e){})}},{key:"loadVideo",value:function(e){return this.callMethod("loadVideo",e)}},{key:"ready",value:function(){var e=K.get(this)||new A(function(e,t){t(new Error("Unknown player. Probably unloaded."))});return A.resolve(e)}},{key:"addCuePoint",value:function(e,t){var n=1<arguments.length&&void 0!==t?t:{};return this.callMethod("addCuePoint",{time:e,data:n})}},{key:"removeCuePoint",value:function(e){return this.callMethod("removeCuePoint",e)}},{key:"enableTextTrack",value:function(e,t){if(!e)throw new TypeError("You must pass a language.");return this.callMethod("enableTextTrack",{language:e,kind:t})}},{key:"disableTextTrack",value:function(){return this.callMethod("disableTextTrack")}},{key:"pause",value:function(){return this.callMethod("pause")}},{key:"play",value:function(){return this.callMethod("play")}},{key:"requestFullscreen",value:function(){return ee.isEnabled?ee.request(this.element):this.callMethod("requestFullscreen")}},{key:"exitFullscreen",value:function(){return ee.isEnabled?ee.exit():this.callMethod("exitFullscreen")}},{key:"getFullscreen",value:function(){return ee.isEnabled?A.resolve(ee.isFullscreen):this.get("fullscreen")}},{key:"requestPictureInPicture",value:function(){return this.callMethod("requestPictureInPicture")}},{key:"exitPictureInPicture",value:function(){return this.callMethod("exitPictureInPicture")}},{key:"getPictureInPicture",value:function(){return this.get("pictureInPicture")}},{key:"remotePlaybackPrompt",value:function(){return this.callMethod("remotePlaybackPrompt")}},{key:"unload",value:function(){return this.callMethod("unload")}},{key:"destroy",value:function(){var n=this;return new A(function(e){var t;K.delete(n),Z.delete(n.element),n._originalElement&&(Z.delete(n._originalElement),n._originalElement.removeAttribute("data-vimeo-initialized")),n.element&&"IFRAME"===n.element.nodeName&&n.element.parentNode&&(n.element.parentNode.parentNode&&n._originalElement&&n._originalElement!==n.element.parentNode?n.element.parentNode.parentNode.removeChild(n.element.parentNode):n.element.parentNode.removeChild(n.element)),n.element&&"DIV"===n.element.nodeName&&n.element.parentNode&&(n.element.removeAttribute("data-vimeo-initialized"),(t=n.element.querySelector("iframe"))&&t.parentNode&&(t.parentNode.parentNode&&n._originalElement&&n._originalElement!==t.parentNode?t.parentNode.parentNode.removeChild(t.parentNode):t.parentNode.removeChild(t))),n._window.removeEventListener("message",n._onMessage),ee.isEnabled&&ee.off("fullscreenchange",n.fullscreenchangeHandler),e()})}},{key:"getAutopause",value:function(){return this.get("autopause")}},{key:"setAutopause",value:function(e){return this.set("autopause",e)}},{key:"getBuffered",value:function(){return this.get("buffered")}},{key:"getCameraProps",value:function(){return this.get("cameraProps")}},{key:"setCameraProps",value:function(e){return this.set("cameraProps",e)}},{key:"getChapters",value:function(){return this.get("chapters")}},{key:"getCurrentChapter",value:function(){return this.get("currentChapter")}},{key:"getColor",value:function(){return this.get("color")}},{key:"getColors",value:function(){return A.all([this.get("colorOne"),this.get("colorTwo"),this.get("colorThree"),this.get("colorFour")])}},{key:"setColor",value:function(e){return this.set("color",e)}},{key:"setColors",value:function(e){if(!Array.isArray(e))return new A(function(e,t){return t(new TypeError("Argument must be an array."))});var t=new A(function(e){return e(null)}),n=[e[0]?this.set("colorOne",e[0]):t,e[1]?this.set("colorTwo",e[1]):t,e[2]?this.set("colorThree",e[2]):t,e[3]?this.set("colorFour",e[3]):t];return A.all(n)}},{key:"getCuePoints",value:function(){return this.get("cuePoints")}},{key:"getCurrentTime",value:function(){return this.get("currentTime")}},{key:"setCurrentTime",value:function(e){return this.set("currentTime",e)}},{key:"getDuration",value:function(){return this.get("duration")}},{key:"getEnded",value:function(){return this.get("ended")}},{key:"getLoop",value:function(){return this.get("loop")}},{key:"setLoop",value:function(e){return this.set("loop",e)}},{key:"setMuted",value:function(e){return this.set("muted",e)}},{key:"getMuted",value:function(){return this.get("muted")}},{key:"getPaused",value:function(){return this.get("paused")}},{key:"getPlaybackRate",value:function(){return this.get("playbackRate")}},{key:"setPlaybackRate",value:function(e){return this.set("playbackRate",e)}},{key:"getPlayed",value:function(){return this.get("played")}},{key:"getQualities",value:function(){return this.get("qualities")}},{key:"getQuality",value:function(){return this.get("quality")}},{key:"setQuality",value:function(e){return this.set("quality",e)}},{key:"getRemotePlaybackAvailability",value:function(){return this.get("remotePlaybackAvailability")}},{key:"getRemotePlaybackState",value:function(){return this.get("remotePlaybackState")}},{key:"getSeekable",value:function(){return this.get("seekable")}},{key:"getSeeking",value:function(){return this.get("seeking")}},{key:"getTextTracks",value:function(){return this.get("textTracks")}},{key:"getVideoEmbedCode",value:function(){return this.get("videoEmbedCode")}},{key:"getVideoId",value:function(){return this.get("videoId")}},{key:"getVideoTitle",value:function(){return this.get("videoTitle")}},{key:"getVideoWidth",value:function(){return this.get("videoWidth")}},{key:"getVideoHeight",value:function(){return this.get("videoHeight")}},{key:"getVideoUrl",value:function(){return this.get("videoUrl")}},{key:"getVolume",value:function(){return this.get("volume")}},{key:"setVolume",value:function(e){return this.set("volume",e)}},{key:"setTimingSrc",value:(n=h(j().mark(function e(t,n){var r,o=this;return j().wrap(function(e){for(;;)switch(e.prev=e.next){case 0:if(t){e.next=2;break}throw new TypeError("A Timing Object must be provided.");case 2:return e.next=4,this.ready();case 4:return r=new $(this,t,n),W(this,"notifyTimingObjectConnect"),r.addEventListener("disconnect",function(){return W(o,"notifyTimingObjectDisconnect")}),e.abrupt("return",r);case 8:case"end":return e.stop()}},e,this)})),function(e,t){return n.apply(this,arguments)})}]),Player}();return n||(Y=function(){for(var e,t=[["requestFullscreen","exitFullscreen","fullscreenElement","fullscreenEnabled","fullscreenchange","fullscreenerror"],["webkitRequestFullscreen","webkitExitFullscreen","webkitFullscreenElement","webkitFullscreenEnabled","webkitfullscreenchange","webkitfullscreenerror"],["webkitRequestFullScreen","webkitCancelFullScreen","webkitCurrentFullScreenElement","webkitCancelFullScreen","webkitfullscreenchange","webkitfullscreenerror"],["mozRequestFullScreen","mozCancelFullScreen","mozFullScreenElement","mozFullScreenEnabled","mozfullscreenchange","mozfullscreenerror"],["msRequestFullscreen","msExitFullscreen","msFullscreenElement","msFullscreenEnabled","MSFullscreenChange","MSFullscreenError"]],n=0,r=t.length,o={};n<r;n++)if((e=t[n])&&e[1]in document){for(n=0;n<e.length;n++)o[t[0][n]]=e[n];return o}return!1}(),Q={fullscreenchange:Y.fullscreenchange,fullscreenerror:Y.fullscreenerror},J={request:function(o){return new Promise(function(e,t){function n(){J.off("fullscreenchange",n),e()}J.on("fullscreenchange",n);var r=(o=o||document.documentElement)[Y.requestFullscreen]();r instanceof Promise&&r.then(n).catch(t)})},exit:function(){return new Promise(function(t,e){var n,r;J.isFullscreen?(n=function e(){J.off("fullscreenchange",e),t()},J.on("fullscreenchange",n),(r=document[Y.exitFullscreen]())instanceof Promise&&r.then(n).catch(e)):t()})},on:function(e,t){var n=Q[e];n&&document.addEventListener(n,t)},off:function(e,t){var n=Q[e];n&&document.removeEventListener(n,t)}},Object.defineProperties(J,{isFullscreen:{get:function(){return Boolean(document[Y.fullscreenElement])}},element:{enumerable:!0,get:function(){return document[Y.fullscreenElement]}},isEnabled:{enumerable:!0,get:function(){return Boolean(document[Y.fullscreenEnabled])}}}),ee=J,function(e){function n(e){"console"in window&&console.error&&console.error("There was an error creating an embed: ".concat(e))}var t=0<arguments.length&&void 0!==e?e:document;[].slice.call(t.querySelectorAll("[data-vimeo-id], [data-vimeo-url]")).forEach(function(t){try{if(null!==t.getAttribute("data-vimeo-defer"))return;var e=G(t);H(b(e),e,t).then(function(e){return B(e,t)}).catch(n)}catch(e){n(e)}})}(),function(e){var r=0<arguments.length&&void 0!==e?e:document;window.VimeoPlayerResizeEmbeds_||(window.VimeoPlayerResizeEmbeds_=!0,window.addEventListener("message",function(e){if(g(e.origin)&&e.data&&"spacechange"===e.data.event)for(var t=r.querySelectorAll("iframe"),n=0;n<t.length;n++)if(t[n].contentWindow===e.source){t[n].parentElement.style.paddingBottom="".concat(e.data.data[0].bottom,"px");break}}))}(),function(e){var a=0<arguments.length&&void 0!==e?e:document;window.VimeoSeoMetadataAppended||(window.VimeoSeoMetadataAppended=!0,window.addEventListener("message",function(e){if(g(e.origin)){var t=D(e.data);if(t&&"ready"===t.event)for(var n=a.querySelectorAll("iframe"),r=0;r<n.length;r++){var o=n[r],i=o.contentWindow===e.source;w(o.src)&&i&&new Player(o).callMethod("appendVideoMetadata",window.location.href)}}}))}(),function(e){var a,t=0<arguments.length&&void 0!==e?e:document;window.VimeoCheckedUrlTimeParam||(window.VimeoCheckedUrlTimeParam=!0,a=function(e){"console"in window&&console.error&&console.error("There was an error getting video Id: ".concat(e))},window.addEventListener("message",function(n){if(g(n.origin)){var e=D(n.data);if(e&&"ready"===e.event)for(var o=t.querySelectorAll("iframe"),i=0;i<o.length;i++)!function(){var r,e=o[i],t=e.contentWindow===n.source;w(e.src)&&t&&(r=new Player(e)).getVideoId().then(function(e){var t,n=new RegExp("[?&]vimeo_t_".concat(e,"=([^&#]*)")).exec(window.location.href);n&&n[1]&&(t=decodeURI(n[1]),r.setCurrentTime(t))}).catch(a)}()}}))}()),Player});
document.addEventListener("DOMContentLoaded", function(event) {
  if ($(window).width() > 768) { // Adjust 768px to your desired desktop breakpoint
    jQuery('.blogFilterG').on('click', function() {
      jQuery(".blogFilterG").not(this).removeClass("active");
      $(this).toggleClass('active'); // Toggle the 'active' class
    });
  }  
    /*   SEARCH ARTICLES  */
  jQuery(".searchBlog").click(function(e){
    e.preventDefault();
    jQuery(".hSearchBlog, .closeSearcBlog").show();
    jQuery(".hFiltersBlog, .searchBlog").hide();
    //jQuery("#searchArticlesInput").focus();
    if (window.matchMedia("(max-width: 767px)").matches) {
        // Focus on the mobile-specific input field
        jQuery("#searchArticleInputM").focus();
    } else {
        // Focus on the desktop input field
        jQuery("#searchArticlesInput").focus();
    }
  })
  jQuery(".closeSearcBlog").click(function(e){
    e.preventDefault();
    jQuery(".searchBlog, .hFiltersBlog").show();
    jQuery(".closeSearcBlog, .hSearchBlog").hide();
  })

  //VIDEO MUTE UNMUTE
  let videoSOF = document.querySelectorAll(".videoSOF");
  videoSOF.forEach((video) => {
    video.addEventListener("click", function(e) {
        if (video.muted === false) {    
            video.muted = true;
        }else{
            video.muted = false;
        }
    });
  });

  // Function to load the YouTube IFrame API if not already loaded
  function loadYouTubeAPI(callback) {
      if (typeof YT === 'undefined' || typeof YT.Player === 'undefined') {
          // Create a script element to load the YouTube API
          var tag = document.createElement('script');
          tag.src = 'https://www.youtube.com/iframe_api';
  
          // Append the script to the head of the document
          var firstScriptTag = document.getElementsByTagName('script')[0];
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  
          // Set up a global callback function for when the API is ready
          window.onYouTubeIframeAPIReady = function() {
              if (typeof callback === 'function') {
                  callback();
              }
          };
      } else {
          // If the API is already loaded, just execute the callback
          if (typeof callback === 'function') {
              callback();
          }
      }
  }
  
  // Function to create the YouTube player
  function createYouTubePlayers() {
      const videoPlayers = document.querySelectorAll('.videoPlayerYT');
      videoPlayers.forEach(player => {
          const videoId = player.dataset.ytId; // Get the YouTube video ID from the data attribute
          if (videoId) {
              new YT.Player(player.id, {
                  videoId: videoId,
                  playerVars: {
                      'autoplay': 0,
                      'controls': 1,
                      'rel': 0
                  }
              });
          }
      });
  }
  const videoPlayers = document.querySelectorAll('.videoPlayerYT');
  if (videoPlayers.length > 0) {
      loadYouTubeAPI(createYouTubePlayers);
  }


	function pauseOtherVideos(current_video){
		jQuery(".youtubePlayer").each(function(){
			if(jQuery(this).data('vimeo-id') != "" && jQuery(this).data('vimeo-id') != undefined ){
				vid = jQuery(this).data('vimeo-id');
				if(vid != current_video ){
					console.log("Pausing " +vid + " != "+current_video);
					window['v'+vid].pause();
				}
			}
		});
	}
    function initializeVimeoVideo(e){
      if(e.data('vimeo-id') != "" && e.data('vimeo-id') != undefined ){
			console.log("create video for id:"+e.data('vimeo-id'));
			vid = e.data('vimeo-id');
			pid = e.attr('id');
			var options = {
				id: vid,
				autopause: true
			};
		    window['v'+vid] = new Vimeo.Player(pid, options);
			window['v'+vid].setAutopause(true);
			window['v'+vid].getAutopause().then(function(autopause) {
				console.log("autopose active for this one");
			});
			//window['v'+vid].on('play', function() {
				//console.log('pausing other videos');
				//pauseOtherVideos(vid);
			//});
			//console.log(window['v'+vid]);
			/*jQuery(this).mouseover(function(){
				jQuery(".youtubePlayer").each(function(){
					if(jQuery(this).data('vid') != "" && jQuery(this).data('vid') != undefined ){
						vid = jQuery(this).data('vid');
						window['v'+vid].pause();
					}
				});
				vid = jQuery(this).data('vid');
				window['v'+vid].play();
			});*/
			/*jQuery(this).mouseover(function(){
				vid = jQuery(this).data('vid');
				console.log('pausing video' + window['v'+vid]);
				window['v'+vid].pause();
			});*/
		}
    }
	jQuery(".youtubePlayer").each(function(){
		initializeVimeoVideo(jQuery(this));
	});
    jQuery(".dCurrencyMenu").click(function(e){
      e.preventDefault();
      jQuery("#languagePop").addClass("active");
      jQuery("body").addClass("tingle-enabled").append('<div id="sideCartOverlay" class="tingle-modal custom-class-1 custom-class-2 tingle-modal--visible"></div>');
    });
    jQuery("body").on("click", "#languagePop .close-button", function(e){
      e.preventDefault();
      jQuery("#languagePop").removeClass("active");
      jQuery("body").removeClass("tingle-enabled");
      jQuery("#sideCartOverlay").remove();
    });
    jQuery(document).on('click', '#sideCartOverlay', function() {
        jQuery(this).remove();
        jQuery("#languagePop").removeClass("active");
        jQuery("body").removeClass("tingle-enabled");
    });
    function updateVideosInElement(e){
      console.log("updateVideosInElement");
      console.log(e);
       jQuery(e).find(".videoPlayer").each(function(){
        initializeVimeoVideo(jQuery(this));
      });
    }
    jQuery("body").on("click", ".button_popup", function(e) {
      e.preventDefault();
      popup_id = jQuery(this).data("popup");
      popup_class = "popup_class";
      if (jQuery(this).data("class")) {
        popup_class = jQuery(this).data("class");
      }
      var modal = new tingle.modal({
          footer: false,
          stickyFooter: false,
          closeMethods: ['overlay', 'button', 'escape'],
          closeLabel: "Close", 
          cssClass: ['custom-class-1', popup_class],
          onOpen: function() {
            updatePricesInElement(modal.getContent());
            updateVideosInElement(modal.getContent());
          },
          onClose: function() { modal.destroy(); },
          beforeClose: function() {
              return true; // close the modal
              return false; // nothing happens
          }
      });
      
      // Check if target popup exists, otherwise use default
      var $target = jQuery("#" + popup_id);
      if ($target.length === 0) {
        popup_id = "defaultShopPayPopup";
        $target = jQuery("#" + popup_id);
      }
      
      var content = $target.html();
      modal.setContent(content);
      modal.open();
      //modal.close(); 
    });
    function updatePricesInElement(rootElement) {
        jQuery(rootElement).find(".shop-price").each(function(){
            var t = jQuery(this);
             if(t.data("price")){
              var base_price = t.data("price");
              var formated_price = get_nice_price(base_price / 100, shop_currency_iso);
              if(t.hasClass("exclude_discount")){
                 t.empty().append(formated_price);
              }else{                  
                  var new_price = get_nice_price(Math.ceil( base_price / 100 * multiplier), shop_currency_iso);
                  var old_price = get_nice_price(base_price / 100, shop_currency_iso);
                  t.empty().append("<span class='priceOld'>" + old_price + "</span><span class='priceNew'>" + new_price + "</span>");
              }
             }
        });
    }
    //BLOG PAGE FLOAT BOXES
    function blogFloatBoxes() {
      console.log("blogFloatBoxes");
      var $articleContent = $('#articleContent');
      var $articleFooter = $('#articleFooter');
      var $box1Container = $('#sidebarBoxW1');
      var $box2Container = $('#sidebarBoxW2');
  
      // Check if elements exist before calculating heights and setting styles
      if ($articleContent.length && $box1Container.length) {
          var contentHeight = $articleContent.outerHeight() - 150;
          $box1Container.css({
            'height': contentHeight + 'px',
            'margin-top': '50px',
            'margin-bottom': '50px',
            'opacity': 1
          });
      }
  
      if ($articleFooter.length && $box2Container.length) {
          var footerHeight = $articleFooter.outerHeight() - 145;
          $box2Container.css({
            'height': footerHeight + 'px',
            'margin-top': '0',
            'opacity': 1  
          });
      }
    }
    function floatSearchBoxes(){
      console.log("floatSearchBoxes");
      var searchResults = $('#searchResults');
      var $articleFooter = $('#articleFooter');
      var $box1Container = $('#sidebarBoxW1');
  
      // Check if elements exist before calculating heights and setting styles
      if (searchResults.length && $box1Container.length) {
          var contentHeight = searchResults.outerHeight();
          $box1Container.css({
            'height': contentHeight + 'px',
            'margin-top': '0',
            'margin-bottom': '0',
            'opacity': 1
          });
      }      
    }
    var mediaQuery = window.matchMedia("(min-width: 64em)");
    if (mediaQuery.matches) {
      if ($('#articleContent').length) {
        setTimeout(() => {
                      blogFloatBoxes();
                  }, 1000);
      }
      if( $('#searchResults').length){
        setTimeout(() => {
                      floatSearchBoxes();
                  }, 1000);
      }
    }
    
    //END BLOG PAGE FLOATING BOXES
    //   AFFILIATE INFO CODE
    var afInfo = getWithExpiry("afInfo");
    afInfo = JSON.parse(afInfo);
    if ( jQuery( "#affiliateInfo" ).length ) {
      var affiliateInfo = JSON.parse(jQuery("#affiliateInfo").html()); 
      var currentDate = new Date();    
      currentDate.setDate(currentDate.getDate() + 7);    
      var options = { year: 'numeric', month: 'short', day: 'numeric' };    
      var formattedDate = currentDate.toLocaleDateString('en-US', options);
      discountCD(formattedDate);
      setWithExpiry("afInfo", JSON.stringify(affiliateInfo), 7*24*60*60*1000);
      jQuery("#stikyB .flexWrappSB").html(affiliateInfo.bellow_title);
    }
	if( afInfo != null ){
      if(jQuery("body").hasClass("template-index")){
           console.log(afInfo);
          //change homepage banner
      }
      jQuery("#stikyB .flexWrappSB").html(afInfo.bellow_title);
    }
    //   END AFFILIATE INFO CODE
    //IF WE're on a campain show strike-through pricing
    var discount_name = null;
    var discount_percentage = 0;
    var discount_active = false;
    if(jQuery("body").data("discount_val") && jQuery("body").data("discount_type")){
      console.log("we're already using a discount");
      discount_active = true;
      discount_percentage = jQuery("body").data("discount_val");
    }else{
      if( afInfo != null ){
  		discount_name = afInfo.discount_name;
  		discount_percentage = afInfo.discount_percentage;
      }else{
        if( 
          jQuery("body").data(" ddiscount_code") != "" && jQuery("body").data(" ddiscount_code_p") != "" ){
          discount_name = jQuery("body").data("ddiscount_code");
          discount_percentage = jQuery("body").data("ddiscount_code_p");  
        }
      }
    }
    multiplier = 1 - (discount_percentage / 100);
    jQuery("body").data("multiplier", multiplier);
    if( discount_active != true){
      fetch('/discount/' + discount_name, {
          method: 'GET',
          headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
          }
      })
      .then(response => {
          if (response.ok) {
            console.log(response);
          } else {
            console.log(response);
          }
      })
      .catch(error => {
          console.error('Error applying discount:', error);
      });
      discount_active = true;
    }
    var shop_currency_symbol = jQuery("body").data("currency_symbol");
    var shop_currency_iso = jQuery("body").data("currency_iso");
    if(shop_currency_iso != "USD"){
      const shipping_currency_val = {
          'GBP': 120,
          'CAD': 210,
          'AUD': 220,
          'EUR': 140,
          'HKD': 1200,
          'JPY': 22000
      };
      jQuery(".convert_currency").each(function(e){
        var new_price =  get_nice_price( Math.ceil( shipping_currency_val[shop_currency_iso] ),shop_currency_iso ) ;
        console.log("new min shipping: "+ new_price);
        jQuery(this).html(new_price);
      });
    }
    if(discount_active == true){
      jQuery(".shop-price:not(.exclude_discount)").each(function(e){
        t = jQuery(this);
        if(t.data("price")){
          var base_price = t.data("price");
          var new_price =  get_nice_price(Math.ceil( base_price  / 100 * multiplier),shop_currency_iso) ;
          var old_price = get_nice_price(base_price / 100, shop_currency_iso);
          t.empty().append("<span class='priceOld'>"+old_price+"</span><span class='priceNew'>"+new_price+"</span>");
        }
      })
    }
    

    jQuery(".hasSubmenu > a").click(function(e){
      e.preventDefault();
      jQuery(this).parent().toggleClass("active");
    });
    jQuery(".sub-nav--title").click(function(e){
      e.preventDefault();
      jQuery("#subNav .hSubNav").toggleClass("active");
      jQuery("html").toggleClass("blogSubnavActive");
    });
    
    jQuery("#toggleMobileMenu").click(function(e){
      jQuery(this).toggleClass("active");
      jQuery("html").toggleClass("mobileMenuActive");
      jQuery("#mobileTopMenu").toggleClass("active");
    });
    jQuery("body").on("click",".qPlus", function(e){
      var ancestor = jQuery(this).closest(".cartPopProduct ");
      addToCart([{
            id: ancestor.data('prod_vid'),
            quantity: 1,
      }]);
    });
    jQuery("body").on("click", ".qMinus", function(e){
        var ancestor = jQuery(this).closest(".cartPopProduct");
        var currentQty = parseInt(ancestor.find(".qVal").attr("data-qty"));
        // Ensure that the quantity is greater than 1 before reducing
        if (currentQty > 1) {
            updateCartQuantity(ancestor.data('cart_item_id'), currentQty - 1);
        }
    });
    jQuery("body").on("click",".addAddOn", function(e){
		    e.preventDefault();
        console.log("addAddOn clicked");
        var isModal = false;
        if ($(this).closest('.tingle-modal').length > 0) {
          var isModal = true;
          var m = $(this).closest('.tingle-modal');
          var targetVid = $(this).attr('data-vid');
        }
        jQuery(this).toggleClass("active");
        if(jQuery(this).hasClass("active")){
          jQuery(this).html("Selected");
          if(isModal == true){
             $('.chooseAddOns .addAddOn[data-vid="' + targetVid + '"]').not('.active').addClass('active').html("Selected");
            var modal = new tingle.modal();
            modal.close();
            m.remove();
          }
        }else{
          jQuery(this).html("Add");
          if(isModal == true){
            $('.chooseAddOns .addAddOn.active[data-vid="' + targetVid + '"]').removeClass('active').html("Add");
          }
        }
        product_addons_table(1);
	});
    if(jQuery(".chooseAddOns").length){
      function product_addons_table(qty, set_addons = false){
    		if(qty == null || qty == undefined){
    			qty = 1;
    		}
        const parray = [];
        var main_product =  getMainProduct();
        if (main_product) {
            var vid = jQuery("#ppATC").data("vid");
            var variant = getVariantDetails(main_product, vid);
            parray.push({
                id: vid,
                quantity: 1,
                price: variant.price,
                title: jQuery("#ppTitle").html()  
            });
        }
        const activeAddons = jQuery(".chooseAddOns .addAddOn.active");
        for (let i = 0; i < activeAddons.length; i++) {
            const addon = jQuery(activeAddons[i]);
            const productId = addon.data('vid');
            const productPrice = addon.data('price'); 
            const quantity = addon.data('qty') || 1;
            const title = addon.closest(".cell").find(".chooseAddOnsTlt").html() || "";
            if (productId) {
                parray.push({
                    id: productId,
                    quantity: quantity,
                    price: productPrice,
                    title: title  
                });
            }
        }
        console.log(parray);
        var chooseAddOnsQt = parray.length;
        jQuery(".totalAddOns").hide();
        if( parray.length > 1){
          jQuery(".totalAddOns").empty().append("<h5>This set includes:</h5>");
          totalValue	= 0;
          for(i=0; i < parray.length; i++){
            totalValue  += Math.ceil(parray[i].price);
            if(discount_active == true){
              var new_price =  get_nice_price(Math.ceil( parray[i].price  / 100 * multiplier),shop_currency_iso) ;
              var old_price = get_nice_price(parray[i].price / 100, shop_currency_iso);
              var price = "<span class='priceOld'>"+old_price+"</span><span class='priceNew'>"+new_price+"</span>";
            }else{
              var price = get_nice_price(parray[i].price, shop_currency_iso);
            }
            jQuery(".totalAddOns").append(
    					`<div class='itemAddOn'>
    						<p class='itemAddOnTlt'>` + parray[i].quantity + `x ` + parray[i].title + `</p>
    						<p class='shop-price'>` + price +`</p>
    					</div>`
    				);
          }
          jQuery(".totalAddOns").append(`<hr>`);
          jQuery(".totalAddOns").show();
          var raw_price = "";
          if(discount_active == true){
            raw_price = Math.ceil( totalValue  / 100 * multiplier);
            var total_new_price =  get_nice_price(raw_price,shop_currency_iso) ;
            var total_old_price = get_nice_price(totalValue / 100, shop_currency_iso);
            var total_price = "<span class='priceOld'>"+total_old_price+"</span><span class='priceNew'>"+total_new_price+"</span>";
            
          }else{
            raw_price = totalValue;
            var total_price = get_nice_price(totalValue, shop_currency_iso);            
          }
          jQuery(".totalAddOns").append(
    				`<div class="totalAddOn">
    					<p class="itemAddOnTotal">Total</p>
    					<p class="shop-price">`+total_price+`</p>
    				</div>`
    			);
          jQuery("#ppPriceSticky").html('<p class="shop-price priceNoPromo" data-price="'+raw_price+'">'+total_price+'</p>');
          updateShopPaySections(totalValue, "defaultShopPayPopup");
        }else{
          if(discount_active == true){
              raw_price = Math.ceil( variant.price  / 100 * multiplier);
              var new_price =  get_nice_price(Math.ceil( variant.price  / 100 * multiplier),shop_currency_iso) ;
              var old_price = get_nice_price(variant.price / 100, shop_currency_iso);
              var price = "<span class='priceOld'>"+old_price+"</span><span class='priceNew'>"+new_price+"</span>";
            }else{
              raw_price = Math.ceil( variant.price );
              var price = get_nice_price(variant.price, shop_currency_iso);
            }
            jQuery("#ppPriceSticky").html('<p class="shop-price priceNoPromo" data-price="'+raw_price+'">'+price+'</p>');
            updateShopPaySections( variant.price, "defaultShopPayPopup");
        }
        
        /*
    			jQuery("#currentProd").data("pids",pids);
    			jQuery("#ppPrice").html(tbHTML);
    		}else{
    			product = getLocalOnlineProduct(pids[0].pid, true); 
    			variant = getVariantFromProduct(product, vid);
    			price 	= create_product_price(product, vid, 1);
    			jQuery("#ppPrice").html(price.html);
    		}
        */
    	}
    }
    function showHideMenus(scrollDir, topScroll){
		menuOffset = 0;
		is_product_page = jQuery( "section.subNav" ).length ? true : false;
		if(is_product_page) submenuOffset = 70;
		showStickyBanner = getCookie("showStickyBanner");
		if(showStickyBanner != "" && jQuery("#isCartPage").length){
			jQuery("#stikyB").show();
		}
        //Apply for products page
        is_products_page = jQuery(".shopSubNav").length ? true : false;
        //is_products_page = true;
        if(is_products_page){
			if(scrollDir == "up"){
                jQuery('section.shopSubNav').addClass("active");
                jQuery("body").addClass("shopSubNavActive");
				if( jQuery(window).scrollTop() < submenuOffset ) {
                    jQuery('section.shopSubNav').removeClass("active");
                    jQuery("body").removeClass("shopSubNavActive");
                }
                if( topScroll == 0){
                    jQuery("body").addClass('showSticky');
                }
			}else{
				if( jQuery(window).scrollTop() > submenuOffset ) {
                    jQuery("body").removeClass("shopSubNavActive");
				}else{
                    jQuery('section.shopSubNav').addClass("active");
                    jQuery("body").addClass("shopSubNavActive");
                }
                jQuery("body").removeClass('showSticky');
			}
		}
		if(is_product_page){
			if(scrollDir == "up"){
				//jQuery("body").removeClass("subMenuActive");
				jQuery('section.subNav').addClass("active");
				jQuery(".bsubmenu").addClass("subNavActive");
				//jQuery("body").addClass("menusActive");
				if( jQuery(window).scrollTop() < submenuOffset ) {
					jQuery('section.subNav').removeClass("active");
					jQuery(".bsubmenu").removeClass("subNavActive");
				}
                if( topScroll == 0){
                    jQuery("body").addClass('showSticky');
                }     
			}else{
				if( jQuery(window).scrollTop() > submenuOffset ) {
					//jQuery("body").removeClass("menusActive");
					jQuery('section.subNav').addClass("active");
					jQuery(".bsubmenu").addClass("subNavActive");
					//jQuery("body").addClass("subMenuActive");
				}
                jQuery("body").removeClass("showSticky");
			}
		}else{
			if( jQuery(window).scrollTop() > menuOffset ) {
				jQuery('#hMenu').addClass("active");
				jQuery("body").addClass("hMenu-active");
			}else{
				jQuery('#hMenu').removeClass("active");
				jQuery("body").removeClass("hMenu-active");
			}
            if(scrollDir == "up" && topScroll == 0){
                    jQuery("body").addClass('showSticky');
            }else{
                jQuery("body").removeClass("showSticky");
            }
		}
	}
    var lastScrollTop = 0;
    jQuery(window).scroll(function(){
        var st = jQuery(this).scrollTop();
        if (st > lastScrollTop && st > 0){
            scrollDir = "down";
            jQuery('body').addClass('scrolling_down');
			jQuery('body').removeClass('scrolling_up');
        } else {
            scrollDir = "up";
            jQuery('body').addClass('scrolling_up');
			jQuery('body').removeClass('scrolling_down');
        }
        showHideMenus(scrollDir, st);
        lastScrollTop = st;

    });
    jQuery("#productShop").click(function(e){
      e.preventDefault();
      jQuery(".tMenuDropdown").not("#tMenuDropdown").removeClass("active");
      jQuery(this).toggleClass("active");
      jQuery("#tMenuDropdown").toggleClass("active");
      jQuery("#productAccessories").removeClass("active");
    });
    jQuery("#productAccessories").click(function(e){
      e.preventDefault();
      jQuery(".tMenuDropdown").not("#tMenuDropdownAccessories").removeClass("active");
      jQuery(this).toggleClass("active");
      jQuery("#tMenuDropdownAccessories, #productShop").toggleClass("active");
      jQuery("#productShop").removeClass("active");
    });
    jQuery("#tMenuDropdownAccessories a").click(function(e){
      jQuery("#productAccessories").click();
    });
    
    jQuery(".products_as_variants .shop-prodVariation, .products_as_variants .shop-prodVariationColor").click(function(e){
      console.log(jQuery(this).data("url"));
      if( jQuery(this).data("url") ){
        window.location = jQuery(this).data("url");
      }
    });
    function updateBundleText(){
      console.log("this is a bundle");
      current_bundle = jQuery(".products_as_variants .product-variation.bundle.active");
      title = current_bundle.find(".shop-prodVariationTlt").html();
      main_qty =  current_bundle.data("bundle_main_qty");
      main_pid = current_bundle.data("bundle_main");
      main_product = jQuery(".product-variations").find(".shop-prodVariation[data-pid='"+main_pid+"']");
      main_prince = main_product.find(".shop-price").data("price");
      total_price = main_prince * main_qty;
      save_price = total_price - current_bundle.find(".shop-price").data("price") * multiplier;
      save_price = get_nice_price(Math.ceil(save_price / 100), shop_currency_iso);
      html = jQuery(".shopInfoBox").html().replace("{{ localized_multi_pack_savings }}", save_price).replace("{{ product_title }}", title);
      console.log(html);
      jQuery(".shopInfoBox").html(html);
}
    if( jQuery(".products_as_variants .product-variation.bundle.active").length > 0){
      updateBundleText(multiplier);
    }
    jQuery("#nav-item-cart").click(function(e){
      e.preventDefault();
      jQuery("#cartPop").addClass("active");
      jQuery("body").addClass("tingle-enabled").append('<div id="sideCartOverlay" class="tingle-modal custom-class-1 custom-class-2 tingle-modal--visible"></div>');
    });
     var path = window.location.pathname;
      if (path === '/cart' || path === '/cart/') {
        jQuery("#nav-item-cart").click();
      }
    jQuery("body").on("click", "#cartPop .close-button", function(e){
      e.preventDefault();
      jQuery("#cartPop").removeClass("active");
      jQuery("body").removeClass("tingle-enabled");
      jQuery("#sideCartOverlay").remove();
    });
    jQuery(document).on('click', '#sideCartOverlay', function() {
        jQuery(this).remove();
        jQuery("#cartPop").removeClass("active");
        jQuery("body").removeClass("tingle-enabled");
    });
    jQuery(".ppATC").click(function(e){
      e.preventDefault();
      if(jQuery(this).hasClass("disabled")){ return false;}
      parray = [];
      var t =  jQuery(this);
      //check if there are addons
      if( jQuery(".chooseAddOns ").length ){
        jQuery(".chooseAddOns .addAddOn.active").each(function() {
            const productId = jQuery(this).data('vid');
            const quantity = jQuery(this).data('qty') || 1;    
            if (productId) {
                parray.push({
                    id: productId,
                    quantity: quantity
                });
            }
        });
      }
      parray.push({
            id: t.data('vid'),
            quantity: 1,
      });
      console.log(parray);
      addToCart(parray);
    });
  jQuery("body").on("click", ".removeCartLine",function(e){
      removeFromCart(jQuery(this).data("id"));
  });
  jQuery('.slider-product-variations-nav').each(function(){
      e = jQuery(this);
      if ( e.children().length > 5) {
        e.slick({
              slidesToShow: 5,
              slidesToScroll: 5,
              infinite: false,
              dots: false,
              arrows: true,
              focusOnSelect: false,
              prevArrow: "<i class='i i-circle_arrow_left'></i>",
              nextArrow: "<i class='i i-circle_arrow_right'></i>",
              responsive: [
                  {
                      breakpoint: 1199,
                      settings: {
                          slidesToShow: 4,
                          slidesToScroll: 1
                      }
                  },
                  {
                      breakpoint: 835,
                      settings: {
                          slidesToShow: 3,
                          slidesToScroll: 1
                      }
                  }
              ]
          });
      }
    });

    function getVariantByOptions2(product, option1, option2) {
        for (let i = 0; i < product.variants.length; i++) {
            const variant = product.variants[i];
            if (variant.option1 === option1 && variant.option2 === option2) {
                return variant;
            }
        }
        return null; // Return null if no matching variant is found
    }

  
    function formatVariantPrice(v){
        if(v.compare_at_price > v.price){
          var html = '<p class="shop-price">';
              html += '<span class="priceOld">' + get_nice_price(Math.ceil(v.compare_at_price/100), shop_currency_iso) + '</span>';
              html += '<span class="priceNew">' + get_nice_price(Math.ceil(v.price * multiplier / 100), shop_currency_iso) + '</span>';
              html += '</p>';
         }else if( multiplier < 1 ) {
            var html = '<p class="shop-price">';
                html += '<span class="priceOld">' + get_nice_price(Math.ceil(v.price / 100), shop_currency_iso) + '</span>';
                html += '<span class="priceNew">' + get_nice_price(Math.ceil(v.price * multiplier / 100), shop_currency_iso) + '</span>';
                html += '</p>';
         }else{
           var html = '<p class="shop-price">'
               html += '<span class="priceNoPromo">' + get_nice_price(Math.ceil(v.price/100), shop_currency_iso) + '</span>';        
               html += '</p>';   
          }
        return html;
    }
    function updateShopPaySections(price, target_e = "defaultShopPayPopup"){
      console.log("Updating default popup ShopPay: " + price);      
      if (typeof price !== "number" || price < 0) {
        console.error("Invalid price value provided");
        return;
      }
      var templateHtml = $("#"+target_e).html();      
      var $templateContent = $(templateHtml);
      $templateContent.find(".shop-price").each(function(){
        var t = $(this);  
        console.log("updating element:", t);                      
        t.attr("data-price", Math.ceil(price/4));
        t.html("");
      });      
      $("#"+target_e).html($templateContent);
      if( jQuery(".product-amount-info").hasClass("exclude_discount") ){
        multiplier = 1;
      }
      jQuery("#productUSPinfo .Monthly").html( get_nice_price( price / 400 * multiplier, shop_currency_iso));
    }
    function updateMainProduct(vid){
      var variant = getVariantDetails(main_product, vid);
      if(variant != null){
        console.log(variant);
        jQuery("#ppTitle").html(variant.name);
        price = formatVariantPrice(variant);
        updateShopPaySections(variant.price)
        jQuery("#ppPrice, #ppPriceSticky").html(price);
        jQuery("#prodAddFix .ppATC, .hPpATC .ppATC").data("vid", variant.id);
      }
    }

    jQuery(".hProductVariations .product-variation").click(function(e){
		var ancestor = $(this).closest('.hProductVariations');
		ancestor.find(".product-variation").removeClass("active");
		jQuery(this).addClass("active");
        var main_product =  getMainProduct();
        if (main_product) {
          if(jQuery("#mainProductJSON").data("options") == 1){
            updateMainProduct(jQuery(this).data("vid"));
          }else{
            o1 = jQuery(".hProductVariations1 .product-variation.active").data("value");
            o2 = jQuery(".hProductVariations2 .product-variation.active").data("value");
            console.log("2 options");
            variant = getVariantByOptions2(main_product, o1, o2);
            if(variant != null){
              jQuery(".ppATC").removeClass("disabled");
              updateMainProduct( variant.id );
            }else{
              jQuery(".ppATC").addClass("disabled");
            }
          }
          console.log("clicked variant");
        }
	});

    jQuery(".slider-product-variations-nav .product-variation:not(.addon)").click(function(e){
        console.log("HEEEEEEEEERE");
		var ancestor = $(this).closest('.productGridBox');
		jQuery(this).parent().find(".product-variation").removeClass("active");
		jQuery(this).addClass("active");
        ancestor.find(".productBoxImg1").attr('src',jQuery(this).data("img1"));
        ancestor.find(".productBoxImg2").attr('src',jQuery(this).data("img2"));
        ancestor.find("a").attr("href", jQuery(this).data("url"));
        ancestor.find("h5 a").html(jQuery(this).data("title"));
        if(discount_active == true){
          var base_price = jQuery(this).data("price_raw");
          var new_price =  get_nice_price(Math.ceil( base_price  / 100 * multiplier),shop_currency_iso) ;
          var old_price = get_nice_price(base_price / 100, shop_currency_iso);
          ancestor.find(".shop-price").empty().append("<span class='priceOld'>"+old_price+"</span><span class='priceNew'>"+new_price+"</span>");
        }else{
          ancestor.find(".shop-price").html(jQuery(this).data("price"));
        }
        
      
	});
    jQuery(".slider-product-variations-nav .product-variation.addon").click(function(e){
        var t = jQuery(this);
		var ancestor = t.closest('.hProductAddon');        
		ancestor.find(".product-variation").removeClass("active");
		t.addClass("active");
        ancestor.find(".productBoxImg1").attr('src', t.data("img1"));
        ancestor.find(".productBoxImg2").attr('src', t.data("img2"));
        //ancestor.find("a").attr("href", t.data("url"));
        ancestor.find(".chooseAddOnsTlt").html(t.data("title"));
        //ancestor.find(".shop-price").html(t.data("price"));
        if(discount_active == true){
          var base_price = t.data("price_raw");
          var new_price =  get_nice_price(Math.ceil( base_price  / 100 * multiplier),shop_currency_iso) ;
          var old_price = get_nice_price(base_price / 100, shop_currency_iso);
          ancestor.find(".shop-price").empty().append("<span class='priceOld'>"+old_price+"</span><span class='priceNew'>"+new_price+"</span>");
        }else{
          ancestor.find(".shop-price").html(t.data("price"));
        }
        ancestor.find(".addAddOn").data("vid", t.data("vid")).data("pid", t.data("pid"));      
	});
    jQuery(".two_col_sq_gal-Slider").each(function(e){
      var id = jQuery(this).data("index");
      jQuery("#two_col_sq_gal-I" + id).slick({
            infinite: false,
            slidesToShow: 2,
            slidesToScroll: 1,
            dots: false,
            arrows: true,
            infinite:true,
            speed: 500,
            appendArrows: jQuery("#two_col_sq_gal-Arrows"+id),
            prevArrow: "<i class='i i-long-arrow-left'></i>",
            nextArrow: "<i class='i i-long-arrow-right'></i>",
            responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    arrows: true,
                    slidesToShow: 1
                  }
                }
              ]
      });
  });
  jQuery('#comparePlaytron').slick({
    infinite: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 2,
          arrows: true,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          infinite: false,
          slidesToShow: 2,
          arrows: true,
          slidesToScroll: 1
        }
      }
    ]
  });
  /*
    function appSlider(){
      jQuery(".appSlider").each(function(){
          if (jQuery(window).width() > 768) {
              var $speed = 15000;
              var sliderContent = document.getElementById(jQuery(this).data("content_desktop")).innerHTML;
          }else{
              var $speed = 15000;
              var sliderContent = document.getElementById(jQuery(this).data("content_mobile")).innerHTML;
          }
          jQuery(this).append(sliderContent);
          jQuery(this).slick({
            speed: $speed,
            autoplay: true,
            autoplaySpeed: 0,
            cssEase: 'linear',
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            swipeToSlide: true,
            centerMode: true,
            focusOnSelect: true,
            arrows: false,          
          });
      });
  }
  appSlider();
  */
  function appSlider() {
    var previousWindowSize = jQuery(window).width() > 768 ? 'desktop' : 'mobile'; // Track the initial state
  
    jQuery(".appSlider").each(function(){
      var $this = jQuery(this); // Cache the current slider
      var $speed = 15000; // Define speed variable once
  
      // Function to initialize or update the slider based on screen width
      function initializeSlider() {
        // Check screen width and set the correct content
        var sliderContent = jQuery(window).width() > 768 ? 
          document.getElementById($this.data("content_desktop")).innerHTML : 
          document.getElementById($this.data("content_mobile")).innerHTML;
  
        // Append content and reinitialize the slider
        $this.html(sliderContent); // Replace content
        $this.slick({
          speed: $speed,
          autoplay: true,
          autoplaySpeed: 0,
          cssEase: 'linear',
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          swipeToSlide: true,
          centerMode: true,
          focusOnSelect: true,
          arrows: false
        });
      }
  
      // Initialize the slider on page load
      initializeSlider();
  
      // Reinitialize the slider on window resize only if the width crosses the 768px threshold
      jQuery(window).resize(function() {
        var currentWindowSize = jQuery(window).width() > 768 ? 'desktop' : 'mobile'; // Detect current state
  
        // Only rebuild the slider if the window size has crossed the 768px threshold
        if (currentWindowSize !== previousWindowSize) {
          // Destroy the slick slider if it already exists
          if ($this.hasClass('slick-initialized')) {
            $this.slick('unslick');
          }
          initializeSlider(); // Reinitialize the slider
          previousWindowSize = currentWindowSize; // Update the state
        }
      });
    });
  }
  
  // Initialize the appSlider function
  appSlider();

  jQuery("a.scrollOffset").click(function(e) {
    e.preventDefault();    
    var target = jQuery(this).attr("href");
    target = target.substring(target.indexOf("#"));
    
    var offset;
    if (jQuery(window).width() > 768) {
        offset = jQuery(this).data("offset-desktop");
    } else {
        jQuery("button.submenu-toggle").click();
        offset = jQuery(this).data("offset-mobile");
    }
    
    if (offset == "" || offset == null || offset == undefined) {
        offset = 0;
    }   

    var targetElement = document.querySelector(target);
    var targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
    });
  });
  $(".ShopGridSlider").slick({
      dots: false,
      arrows: false,
      infinite: false,
      speed: 200,
      slidesToShow: 3,
      slidesToScroll: 3,
      mobileFirst: true,
      swipeToSlide: true,
      cssEase: 'cubic-bezier(0.42, 0, 1, 1)',
      responsive: [
      {
        breakpoint: 480,
        settings: {
          autoplay: false,
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: false,
          dots: false
        }
      },
      {
        breakpoint: 640,
        settings: {
          autoplay: false,
          slidesToShow: 4,
          slidesToScroll: 4,
          infinite: false,
          swipeToSlide: true,
          dots: false
        }
      },
      {
        breakpoint: 1024,
        settings: {
            slidesToShow: 5,
            slidesToScroll: 4,
            infinite: false,
            dots: false
        }
      },
      {
        breakpoint: 1200,
        settings: {
            slidesToShow: 7,
            slidesToScroll: 4,
            infinite: false,
            dots: false
        }
      }
    ]
  });


  
  var main_product =  getMainProduct();
  if (main_product) {
    //console.log(main_product);
    new_images = get_images_from_product_graphql(main_product.images, main_product.variants);
    product_details_add_imgs(new_images);
    product_details_imgs_slider();
  }

  jQuery(".accordion-item > a, .accordion-item .accordion-title").click(function(e){
    e.preventDefault();
    //jQuery(this).parent().toggleClass("is-active");
    // Remove 'is-active' class from all siblings first
    jQuery(this).closest('.accordion-item').siblings('.accordion-item').removeClass('is-active');
    // Then toggle the class on the parent of the clicked element
    jQuery(this).closest('.accordion-item').toggleClass('is-active');

  });
    var e =  document.getElementById("ratingPanel");
    if (typeof(e) != 'undefined' && e != null){
    	loadScript("https://widget.reviews.io/combined/dist.js?v1", function() {
          var skuData = document.getElementById("ratingPanel").getAttribute('data-skus');
    	  document.getElementById("ReviewsWidget").innerHTML = "";
    		new ReviewsWidget('#ReviewsWidget', {
    			store: 'soundbrenner',
    			widget: 'combined-widget',
    			options: {
    				types: 'product_review',
    				per_page: 3,    
    				product_review: {
    					sku: skuData,  //Multiple SKU's seperated by semicolon
    					enable_write_review:true,
    					enable_smart_filters:true,
    					enable_rating_filters:true,
    					enable_toggle_filters:true,
    					enable_social_sharing:false,
    					enable_helpful:false,
    					enable_featured_review_photos:true,
    					enable_featured_social_photos:true,
    					show_mention_text:true,
    					show_dates:true,
    					show_replies:true,
    					show_avatars:true,
    					show_photos:true,
    					show_verify_status:true
    
    				},
    			},
    			styles: {
    				starColor:'#ea983e',
    				textColor:'#fff',
    				primaryColor:'#00c2a3',
    				textColor:'#fff',
    				neutralColor:'#525252',
    				backgroundColor:'#000',
    				formColor:'#dcdcdc',
    				baseTextSize:'14px',
    				header_style:''
    			},
    			buttons:{
    				smart_filter:'solid',
    				write_review:'solid',
    				selected_page:'outline'
    			},
    			avatars:{
    				enable_gravatar:true,
    				gravatar_fallback:'identicon'
    			},
    			reviewsLogo:{
    				show_logo:true,
    				style:'white'
    			}	
    		});     
            loadScript("https://widget.reviews.io/rating-snippet/dist.js", function() {
              ratingSnippet("ruk_rating_snippet",{
                store: "soundbrenner",
                color: "#ffde35",
                linebreak: false,
                text: "reviews"
              });
            });
    	});
    }
  
  const shareButtons = document.querySelectorAll('.share-buttons');

  shareButtons.forEach(buttonGroup => {
    const url = buttonGroup.getAttribute('data-url');
    const title = buttonGroup.getAttribute('data-title');
    const thumbnail = buttonGroup.getAttribute('data-thumb');
    const copiedMessage = buttonGroup.querySelector('.copiedToClipboard');

    buttonGroup.querySelector('.share-facebook').addEventListener('click', function() {
      const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}&t=${encodeURIComponent(title)}`;
      window.open(facebookUrl, '_blank');
    });

    buttonGroup.querySelector('.share-twitter').addEventListener('click', function() {
      const twitterUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(title)}`;
      window.open(twitterUrl, '_blank');
    });

    buttonGroup.querySelector('.share-email').addEventListener('click', function() {
      const emailUrl = `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(url)}`;
      window.location.href = emailUrl;
    });

    buttonGroup.querySelector('.share-link').addEventListener('click', function() {
      const tempInput = document.createElement('input');
      tempInput.value = url;
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand('copy');
      document.body.removeChild(tempInput);

      copiedMessage.classList.add('active');
      setTimeout(() => {
        copiedMessage.classList.remove('active');
      }, 5000);
    });
  });

   // Function to initialize the Klaviyo form
    function initializeFooterKlaviyo(){
      KlaviyoSubscribe.attachToForms('#email_signup', {
          hide_form_on_success: true,
          success_message: "Thank you for signing up. Please check your inbox for a confirmation email."
      });
    }
    let attemptCounter = 0; 
    function initKlaviyoForm() {
        attemptCounter++;
        if (typeof KlaviyoSubscribe !== 'undefined' && typeof KlaviyoSubscribe.attachToForms === 'function') {
            initializeFooterKlaviyo();
            clearInterval(checkKlaviyoInterval);
        } else if (attemptCounter >= 5) {
            clearInterval(checkKlaviyoInterval);
            console.log('Klaviyo failed to load after 5 attempts.');
            loadScript("https://www.klaviyo.com/media/js/public/klaviyo_subscribe.js", function() {
              initializeFooterKlaviyo();
            });
        }
    }

    // Set an interval to check if Klaviyo is loaded, with a limit of 5 attempts
    var checkKlaviyoInterval = setInterval(initKlaviyoForm, 100);
});
